export * from './condition'
export * from './bulletin_board'


export const isInvProd = {
    body: {
        isINV_PROD: false,
    },
    header: {
        message: "↵API Success",
        status: "0",
        userDeviceIp: "10.95.33.59",
        userId: "C18768708E",
    },
}

export const checkIns = {
    header: {
        "message": "\r\n查詢成功",
        "userId": "C18768708E",
        "userDeviceIp": "10.87.23.52",
        "status": "200",
    },
    body: {
        "returnmsg": "檢核正確",
        "returncode": "0",
        "detail": {
            "ceplcno": "3760501319",
            "isout": "0",
        }
    }
}

export const progress1 = {
    body: {
        data_list: [
            {
                APC_NAME: "廖○億              ",
                APLY_STS_ALL: "簽收：保單已簽收",
                APPLY_NO: "MB20197586",
                INPUT_DATE: "2019-04-16 23:55:10.0",
                INSD_NAME: "廖○億              ",
                POLICY_NO: "0000000000",
                PROD_NM: "DI",
            },
            {
                APC_NAME: "廖○億              ",
                APLY_STS_ALL: "<font color=red>不全：尚有補全未完成，請連繫保戶完成補全事項<br>請款：信用卡請款失敗",
                APPLY_NO: "MC70700633",
                INPUT_DATE: "2019-04-17 17:20:42.0",
                INSD_NAME: "廖○億              ",
                POLICY_NO: "0000000000",
                PROD_NM: "IG3",
            },
            {
                APC_NAME: "廖○億              ",
                APLY_STS_ALL: "註銷：註銷<br>請款：轉帳請款失敗",
                APPLY_NO: "MB21789275",
                INPUT_DATE: "2019-03-04 23:59:23.0",
                INSD_NAME: "廖○億              ",
                POLICY_NO: "0000000000",
                PROD_NM: "Q0",
            },
            {
                APC_NAME: "廖○億              ",
                APLY_STS_ALL: "簽收：保單已簽收",
                APPLY_NO: "MC65120383",
                INPUT_DATE: "2018-10-31 23:50:44.0",
                INSD_NAME: "廖○億              ",
                POLICY_NO: "9169911522",
                PROD_NM: "AGA",
            },
            {
                APC_NAME: "廖○億              ",
                APLY_STS_ALL: "簽收：保單已簽收",
                APPLY_NO: "MB20197586",
                INPUT_DATE: "2019-04-16 23:55:10.0",
                INSD_NAME: "廖○億              ",
                POLICY_NO: "0000000000",
                PROD_NM: "DI",
            },
        ]
    },
    header: {
        message: "↵API Success",
        status: "200",
        userDeviceIp: "10.95.33.59",
        userId: "C18768708E",
    }
}

export const queryPayRecord = {
    body: {
        CHANGE_LIST: [
            {
                ACPT_ACNT_NO: "",
                ACPT_BANK_NO_CH: "",
                AGNT_NAME: "廖○億",
                APC_NAME: "葉○卿",
                APLY_DATE: "2016-03-09",
                APLY_NO: "R003681268",
                APLY_STS_CH: "覆核",
                EFT_DATE: "2016-03-10",
                INSD_NAME: "廖○億",
                POLICY_NO: "7205332370",
                PROD_NAME: "美滿人生３１２（終生險）８６年１月１後（含）",
                TRN_KIND: "ABR004",
                TRN_KIND_CH: "收費地址變更",
            },
            {
                ACPT_ACNT_NO: "",
                ACPT_BANK_NO_CH: "",
                AGNT_NAME: "廖○億",
                APC_NAME: "廖○億",
                APLY_DATE: "2016-03-09",
                APLY_NO: "R003681268",
                APLY_STS_CH: "覆核",
                EFT_DATE: "2016-03-10",
                INSD_NAME: "廖○億",
                POLICY_NO: "7208020786",
                PROD_NAME: "富貴保本三福壽險（９９歲險）８６年１月１後（含）",
                TRN_KIND: "ABR004",
                TRN_KIND_CH: "收費地址變更",
            },
            {
                ACPT_ACNT_NO: "",
                ACPT_BANK_NO_CH: "",
                AGNT_NAME: "廖○億",
                APC_NAME: "葉○卿",
                APLY_DATE: "2016-03-09",
                APLY_NO: "R003681268",
                APLY_STS_CH: "覆核",
                EFT_DATE: "2016-03-10",
                INSD_NAME: "廖○億",
                POLICY_NO: "7229209056",
                PROD_NAME: "防癌終身健康保險－個人型",
                TRN_KIND: "ABR004",
                TRN_KIND_CH: "收費地址變更",
            },
        ]
    },
    header: {
        message: "↵API Success",
        status: "200",
        userDeviceIp: "10.95.33.59",
        userId: "C18768708E",
    }
}

export const getUserSSO = {
    body: {
        ip: "10.87.23.53",
        userInfo: {
            apiKeyFunctionsPermission: {
                'd9bb0229-2f53-46c8-a056-3cbf6a9f743f':{
                    CONTENT_MANAGEMENT_SYSTEM: true,
                    CONTENT_VERIFICATION_SYSTEM: true,
                    SUPERVISOR_AREA_01: true,
                    SUPERVISOR_AREA_02: true,
                    SUPERVISOR_AREA_03: true,
                    SUPERVISOR_AREA_04: true,
                    SUPERVISOR_AREA_05: true,
                    SWITCH_USER: true,
                    SYSTEM_MANAGEMENT: true,
                    USER_PROFILE: true,
                },
            },
            apiKeys: ["d9bb0229-2f53-46c8-a056-3cbf6a9f743f"],
            functionId: ['1','2'],
            divFullName: "展業信義通訊處（一）展業二課一區",
            divNo: "AH42100",
            divShortName: "展信義二１",
            id: "C10797445C",
            manager: true,
            mktDeptName: "展業北三區",
            mktDeptNo: "AC00000",
            name: "廖○億",
            position: "QE",
            positionFullName: "展業區襄理（二）",
            positionShortName: "展業區襄理（二）",
            roleId: "SALES_MANAGER_02",
            userCategoryId: "45",
            workDate: "10809工 第13天",
        },
        workDate: "10809工 第13天",
    },
    header:{
        status: "200",
    }
}

export const service = {
    body: {
        detail: [
            {SERVICE_DETAIL: "客戶最近有上網瀏覽VIP服務專區，快快拜訪！了解客戶需要，提供他最好服務！", SERVICE_SOURCE: "線上瀏覽", type: "3"},
            {SERVICE_DETAIL: "保戶2019-01-22於櫃檯辦理職業類別變更，保戶換工作了？！有機會增員嗎？(保單號碼：9999900000)", SERVICE_SOURCE: "臨櫃申辦", type: "2"},
            {SERVICE_DETAIL: "客戶於1/22進線0800詢問保全給付紅利的問題，客戶是不是對於給付紅利有問題，趕快去關心客戶是否需要協助！", SERVICE_SOURCE: "0800", type: "1"}
        ]
    }
}

export const cathayInsurance = {
    body: {
        policies: [
            {
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 21210,
                child: [{
                    apc_id: "A18817186J",
                    apc_name: "周○雄",
                    bre_prem: 21210,
                    cul_prem: 0,
                    curr: "NTD",
                    face_amt: 70,
                    face_amt_unit: "萬",
                    fet_name: "停效",
                    insd_id: "H28645123I",
                    insd_name: "詹○菊",
                    issue_date: "1992-05-26 00:00:00.0",
                    pay_freq: "年繳",
                    pay_kind: "自繳件",
                    pay_prd: 30,
                    policy_no: "3801551733",
                    prod_cat: "2",
                    prod_id: "AD_       ",
                    prod_nm: "新傷特-家庭型死殘"
                },
                {
                    apc_id: "A18817186J",
                    apc_name: "周○雄",
                    bre_prem: 21210,
                    cul_prem: 0,
                    curr: "NTD",
                    face_amt: 70,
                    face_amt_unit: "萬",
                    fet_name: "停效",
                    insd_id: "H28645123I",
                    insd_name: "詹○菊",
                    issue_date: "1992-05-26 00:00:00.0",
                    pay_freq: "年繳",
                    pay_kind: "自繳件",
                    pay_prd: 30,
                    policy_no: "3801551733",
                    prod_cat: "2",
                    prod_id: "AD2_      ",
                    prod_nm: "新傷特-家庭型死殘"                    
                    
                }],
                cul_prem: 21210,
                curr: "NTD",
                face_amt: 70,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H28645123I",
                insd_name: "詹○菊",
                issue_date: "1992-05-26 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801551733",
                prod_cat: "1",
                prod_id: "FL        ",
                prod_nm: "萬代福211終身"
            }, { 
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 21210,
                cul_prem: 0,
                curr: "NTD",
                face_amt: 70,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H28645123I",
                insd_name: "詹○菊",
                issue_date: "1992-05-26 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801551733",
                prod_cat: "2",
                prod_id: "AD_       ",
                prod_nm: "新傷特-家庭型死殘"
            }, { 
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 21210,
                cul_prem: 0,
                curr: "NTD",
                face_amt: 70,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H28645123I",
                insd_name: "詹○菊",
                issue_date: "1992-05-26 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801551733",
                prod_cat: "2",
                prod_id: "AD2_      ",
                prod_nm: "新傷特-家庭型死殘"
            }, {
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 33400,
                child: [{
                    apc_id: "A18817186J",
                    apc_name: "周○雄",
                    bre_prem: 33400,
                    cul_prem: 0,
                    curr: "NTD",
                    face_amt: 100,
                    face_amt_unit: "萬",
                    fet_name: "停效",
                    insd_id: "H18660476E",
                    insd_name: "江○滄",
                    issue_date: "1993-08-28 00:00:00.0",
                    pay_freq: "年繳",
                    pay_kind: "自繳件",
                    pay_prd: 30,
                    policy_no: "3801875431",
                    prod_cat: "2",
                    prod_id: "AD_       ",
                    prod_nm: "新傷特-家庭型死殘"
                },
                {
                    apc_id: "A18817186J",
                    apc_name: "周○雄",
                    bre_prem: 33400,
                    cul_prem: 0,
                    curr: "NTD",
                    face_amt: 100,
                    face_amt_unit: "萬",
                    fet_name: "停效",
                    insd_id: "H18660476E",
                    insd_name: "江○滄",
                    issue_date: "1993-08-28 00:00:00.0",
                    pay_freq: "年繳",
                    pay_kind: "自繳件",
                    pay_prd: 30,
                    policy_no: "3801875431",
                    prod_cat: "2",
                    prod_id: "AD2_      ",
                    prod_nm: "新傷特-家庭型死殘"                 
                    
                },
                {
                    apc_id: "A18817186J",
                    apc_name: "周○雄",
                    bre_prem: 33400,
                    cul_prem: 0,
                    curr: "NTD",
                    face_amt: 100,
                    face_amt_unit: "萬",
                    fet_name: "停效",
                    insd_id: "H18660476E",
                    insd_name: "江○滄",
                    issue_date: "1993-08-28 00:00:00.0",
                    pay_freq: "年繳",
                    pay_kind: "自繳件",
                    pay_prd: 30,
                    policy_no: "3801875431",
                    prod_cat: "2",
                    prod_id: "AE_       ",
                    prod_nm: "新傷特-家庭型住院"                    
                },
                {
                    apc_id: "A18817186J",
                    apc_name: "周○雄",
                    bre_prem: 33400,
                    cul_prem: 0,
                    curr: "NTD",
                    face_amt: 100,
                    face_amt_unit: "萬",
                    fet_name: "停效",
                    insd_id: "H18660476E",
                    insd_name: "江○滄",
                    issue_date: "1993-08-28 00:00:00.0",
                    pay_freq: "年繳",
                    pay_kind: "自繳件",
                    pay_prd: 30,
                    policy_no: "3801875431",
                    prod_cat: "2",
                    prod_id: "AO_       ",
                    prod_nm: "防癌終身附約-雙親型"                    
                }],
                cul_prem: 33400,
                curr: "NTD",
                face_amt: 100,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H18660476E",
                insd_name: "江○滄",
                issue_date: "1993-08-28 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801875431",
                prod_cat: "1",
                prod_id: "FL        ",
                prod_nm: "萬代福211終身"
            }, {
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 33400,
                cul_prem: 0,
                curr: "NTD",
                face_amt: 100,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H18660476E",
                insd_name: "江○滄",
                issue_date: "1993-08-28 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801875431",
                prod_cat: "2",
                prod_id: "AD_       ",
                prod_nm: "新傷特-家庭型死殘"
            }, {
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 33400,
                cul_prem: 0,
                curr: "NTD",
                face_amt: 100,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H18660476E",
                insd_name: "江○滄",
                issue_date: "1993-08-28 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801875431",
                prod_cat: "2",
                prod_id: "AD2_      ",
                prod_nm: "新傷特-家庭型死殘"
            }, {
                cul_prem: 0,
                curr: "NTD",
                face_amt: 500,
                face_amt_unit: "元",
                fet_name: "終止",
                insd_id: "C18768708E",
                insd_name: "廖○億",
                issue_date: "2010-07-14 00:00:00.0",
                pay_prd: 1,
                policy_no: "9044983289",
                prod_cat: "2",
                prod_id: "BP_",
                prod_nm: "國泰人壽全方位傷害醫療日額"
            }, {
                apc_id: "A18817186J",
                apc_name: "周○雄",
                bre_prem: 33400,
                cul_prem: 0,
                curr: "NTD",
                face_amt: 100,
                face_amt_unit: "萬",
                fet_name: "停效",
                insd_id: "H18660476E",
                insd_name: "江○滄",
                issue_date: "1993-08-28 00:00:00.0",
                pay_freq: "年繳",
                pay_kind: "自繳件",
                pay_prd: 30,
                policy_no: "3801875431",
                prod_cat: "2",
                prod_id: "AE_       ",
                prod_nm: "新傷特-家庭型住院"
            }, {
                cul_prem: 0,
                curr: "NTD",
                face_amt: 10,
                face_amt_unit: "計劃別",
                fet_name: "終止",
                insd_id: "C18768708E",
                insd_name: "廖○億",
                issue_date: "2004-11-24 00:00:00.0",
                pay_prd: 1,
                policy_no: "7252612402",
                prod_cat: "2",
                prod_id: "BF_",
                prod_nm: "國泰人壽全意住院醫療保險附約"
            },  {
                cul_prem: 0,
                curr: "NTD",
                face_amt: 700,
                face_amt_unit: "元",
                fet_name: "正常",
                insd_id: "C18768708E",
                insd_name: "廖○億",
                issue_date: "2013-03-27 00:00:00.0",
                pay_prd: 1,
                policy_no: "9085013090",
                prod_cat: "2",
                prod_id: "BG_",
                prod_nm: "國泰人壽全心住院日額健康保險附約"
            },
        ],
        deletelifeinsurancelist: [
            {
                insuranceamount: '112315',
                insuredname: '誰知道',
                policynumber: '776677667',
                product: '商品',
                yearperiodtobuy: '12',
                isrelation: false,
                policy: [
                    {
                        policy_no: '12314564615',
                        prod_nm: '機八險',
                        apc_id: 'C18158751E',
                        apc_name: '王曉明',
                        insd_id: 'I145641154B',
                        insd_name: '孫小美',
                        pay_prd: '20',
                        issue_date: '2018-10-10', //投保始期
                        bre_prem: '99999', //契約保費
                        face_amt: '8888' || '', //保額/計劃別
                        face_amt_unit: '4', //保額/計劃別 單位
                        cul_prem: '77777', //保單總繳
                        pay_freq: '月繳', // 繳別 // 繳費方式
                        pay_kind: '現金',
                        currency: '4564564', //契約
                        bank_name: '國泰銀行', //扣款銀行名稱
                        account_no: '5555', //扣款帳號/信用卡後四碼
                        fet_name: '20', //契約效力
                        prod_id: 'A77886', //險別代號,
                        prod_cat: '1',  // 判斷主附約
                    },
                    {
                        policy_no: '12314564615',
                        prod_nm: '機八險',
                        apc_id: 'C18158751E',
                        apc_name: '王曉明',
                        insd_id: 'I145641154B',
                        insd_name: '孫小美',
                        pay_prd: '20',
                        issue_date: '2018-10-10', //投保始期
                        bre_prem: '99999', //契約保費
                        face_amt: '8888' || '', //保額/計劃別
                        face_amt_unit: '4', //保額/計劃別 單位
                        cul_prem: '77777', //保單總繳
                        pay_freq: '月繳', // 繳別 // 繳費方式
                        pay_kind: '現金',
                        currency: '4564564', //契約
                        bank_name: '國泰銀行', //扣款銀行名稱
                        account_no: '5555', //扣款帳號/信用卡後四碼
                        fet_name: '20', //契約效力
                        prod_id: 'A77886', //險別代號,
                        prod_cat: '0',  // 判斷主附約
                    },
                    {
                        policy_no: '12314564615',
                        prod_nm: '機八險',
                        apc_id: 'C18158751E',
                        apc_name: '王曉明',
                        insd_id: 'I145641154B',
                        insd_name: '孫小美',
                        pay_prd: '20',
                        issue_date: '2018-10-10', //投保始期
                        bre_prem: '99999', //契約保費
                        face_amt: '8888' || '', //保額/計劃別
                        face_amt_unit: '4', //保額/計劃別 單位
                        cul_prem: '77777', //保單總繳
                        pay_freq: '月繳', // 繳別 // 繳費方式
                        pay_kind: '現金',
                        currency: '4564564', //契約
                        bank_name: '國泰銀行', //扣款銀行名稱
                        account_no: '5555', //扣款帳號/信用卡後四碼
                        fet_name: '20', //契約效力
                        prod_id: 'A77886', //險別代號,
                        prod_cat: '0',  // 判斷主附約
                    },
                    {
                        policy_no: '12314564615',
                        prod_nm: '機八險',
                        apc_id: 'C18158751E',
                        apc_name: '王曉明',
                        insd_id: 'I145641154B',
                        insd_name: '孫小美',
                        pay_prd: '20',
                        issue_date: '2018-10-10', //投保始期
                        bre_prem: '99999', //契約保費
                        face_amt: '8888' || '', //保額/計劃別
                        face_amt_unit: '4', //保額/計劃別 單位
                        cul_prem: '77777', //保單總繳
                        pay_freq: '月繳', // 繳別 // 繳費方式
                        pay_kind: '現金',
                        currency: '4564564', //契約
                        bank_name: '國泰銀行', //扣款銀行名稱
                        account_no: '5555', //扣款帳號/信用卡後四碼
                        fet_name: '20', //契約效力
                        prod_id: 'A77886', //險別代號,
                        prod_cat: '0',  // 判斷主附約
                    },
                ]
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "1.2.3.4",
        userId: "C18768708E"
    }
}

export const getCustOtherInsurance = {
    body: {
        code: "0000",
        codemsg: "成功",
        insuredcontractlist:[
            {
                birthday: "68/4/20",
                contractcontentlist:[
                    {
                        annuity: "廖○億",
                        applicant: "廖○億",
                        birthdaygoodwishbenefit: "廖○億",
                        company: "南山人壽  ",
                        companyid: "2007643ddf584961aa9ad51d0f65d0b2",
                        contractid: "7efce8ce3e9e4da0b547022070e7349d",
                        contracttype: "主約",
                        deathbenefit: "廖○億",
                        insuranceamount: "10單位",
                        insurancedate: "107/5/2",
                        insurancevalue: "",
                        maturitybenefit: "廖○億",
                        paymentway: "年繳",
                        policyid: "027f22e06b03440d9209fd256c4885bc",
                        policynumber: "0000000000",
                        premium: "100,000元",
                        product: "好安心手術醫療終身保險",
                        relatedtoprimaryinsured: "本人",
                        yearperiodtobuy: "20",
                    },
                ],
                fullname: "蘇○瑜",
                personalid: "D28782340D",
            },
            {
                birthday: "103/3/3",
                contractcontentlist:[
                    {
                        annuity: "廖○億",
                        applicant: "廖○億",
                        birthdaygoodwishbenefit: "法定繼承人",
                        company: "新光人壽  ",
                        companyid: "f5040bcf5f2f42e2bce5793ac5b36238",
                        contractid: "eee2fe619ae647da8be588b1f152b739",
                        contracttype: "主約",
                        deathbenefit: "廖○億",
                        insuranceamount: "USD100元",
                        insurancedate: "106/5/2",
                        insurancevalue: "",
                        maturitybenefit: "廖○億",
                        paymentway: "躉繳",
                        policyid: "48af7fcf0d334dc48568d81bdebeb94a",
                        policynumber: "0000000000",
                        premium: "USD 100元",
                        product: "一路發美元終身還本保險",
                        relatedtoprimaryinsured: "本人",
                        yearperiodtobuy: "06",
                    },
                ],
                fullname: "廖○晴",
                personalid: "A29884430I",
            },
            {
                birthday: "99/5/20",
                contractcontentlist:[
                    {
                        annuity: "",
                        applicant: "",
                        birthdaygoodwishbenefit: "",
                        company: "南山人壽  ",
                        companyid: "2007643ddf584961aa9ad51d0f65d0b2",
                        contractid: "7ac131b218f749a8b39550e71d262d11",
                        contracttype: "主約",
                        deathbenefit: "",
                        insuranceamount: "1萬",
                        insurancedate: "100/5/2",
                        insurancevalue: "",
                        maturitybenefit: "",
                        paymentway: "年繳",
                        policyid: "26f66752971a421e8c96a5bef524a627",
                        policynumber: "0000000000",
                        premium: "20,000元",
                        product: "新康順終身保險",
                        relatedtoprimaryinsured: "本人",
                        yearperiodtobuy: "20",
                    },
                    {
                        annuity: "",
                        applicant: "",
                        birthdaygoodwishbenefit: "",
                        company: "南山人壽  ",
                        companyid: "2007643ddf584961aa9ad51d0f65d0b2",
                        contractid: "9555b6b094e0458488a176fb4c6089e9",
                        contracttype: "附約",
                        deathbenefit: "",
                        insuranceamount: "1000元",
                        insurancedate: "100/5/2",
                        insurancevalue: "",
                        maturitybenefit: "",
                        paymentway: "年繳",
                        policyid: "26f66752971a421e8c96a5bef524a627",
                        policynumber: "0000000000",
                        premium: "1,000元",
                        product: "傷害保險附約",
                        relatedtoprimaryinsured: "本人",
                        yearperiodtobuy: "01",
                    },
                ],
                fullname: "廖○億",
                personalid: "C18768708E",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

// export const otherInsurance = {
//     body: {
//         policies: {
//             agidno: "C18768708E",
//             apcnm: "",
//             contracts: [
//                 {
//                     anty_pay_date: "",
//                     bnf_annuity_nm: "",
//                     bnf_birth_nm: "",
//                     bnf_death_nm: "楊○惠",
//                     bnf_matag_nm: "",
//                     companyname: "南山人壽",
//                     contract_type: "主約",
//                     currencytype: "1",
//                     famt: "20.000000",
//                     famt_ntd: "200000.000000",
//                     issue_date: "1997-12-23 00:00:00.0",
//                     min_guaran_die: "",
//                     min_guaran_due: "",
//                     name: "楊○助",
//                     pay_freq: "月繳",
//                     plcvl: "0.000000",
//                     prd: "20",
//                     prem: "1063.000000",
//                     prem_ntd: "1063.000000",
//                     productname: "美滿還本終身壽險",
//                     productunit: "萬",
//                     sche_amt: "",
//                     sche_nm: "",
//                     unit_no: "",
//                     year_type: "年"
//                 },
//                 {
//                     anty_pay_date: "",
//                     bnf_annuity_nm: "",
//                     bnf_birth_nm: "",
//                     bnf_death_nm: "",
//                     bnf_matag_nm: "",
//                     companyname: "南山人壽",
//                     contract_type: "主約",
//                     currencytype: "1",
//                     famt: "20.000000",
//                     famt_ntd: "200000.000000",
//                     issue_date: "1997-12-23 00:00:00.0",
//                     min_guaran_die: "",
//                     min_guaran_due: "",
//                     name: "楊○助",
//                     pay_freq: "月繳",
//                     plcvl: "0.000000",
//                     prd: "20",
//                     prem: "1234.000000",
//                     prem_ntd: "1234.000000",
//                     productname: "全新增額養老壽險",
//                     productunit: "萬",
//                     sche_amt: "",
//                     sche_nm: "",
//                     unit_no: "",
//                     year_type: "年"
//                 },
//                 {
//                     anty_pay_date: "",
//                     bnf_annuity_nm: "",
//                     bnf_birth_nm: "",
//                     bnf_death_nm: "楊○惠",
//                     bnf_matag_nm: "",
//                     companyname: "南山人壽                            ",
//                     contract_type: "主約",
//                     currencytype: "1",
//                     famt: "20.000000",
//                     famt_ntd: "200000.000000",
//                     issue_date: "1997-12-23 00:00:00.0",
//                     min_guaran_die: "",
//                     min_guaran_due: "",
//                     name: "楊○助",
//                     pay_freq: "月繳",
//                     plcvl: "0.000000",
//                     prd: "18",
//                     prem: "1345.000000",
//                     prem_ntd: "1345.000000",
//                     productname: "金美滿還本終身保險",
//                     productunit: "萬",
//                     sche_amt: "",
//                     sche_nm: "",
//                     unit_no: "",
//                     year_type: "年"
//                 }
//             ],
//             display_order: "10",
//             issuggestpolicy: "否",
//             plcno: "N124171611",
//             sugno: "",
//         }
//     },
//     header: {
//         message: "查詢成功",
//         status: "200",
//         userDeviceIp: "10.87.23.53",
//         userId: "C18768708E",
//     }
// }

export const otherFire = {
    body: [
        {
            no: 'FIRETEST001',
            company: '富邦產物保險公司',
            client: '陳怡君',
            type: '住宅火險',
            duration: ['107/01/31', '108/01/31'],
            fee: 1000,
            address: '台北市萬華區環河南路二段274巷5弄4號2樓'
        }
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const otherCar = {
    body: [
        {
            no: 'FIRETEST001',
            company: '富邦產物保險公司',
            client: '陳怡君',
            type: '汽車險（任意險）',
            duration: ['107/01/31', '108/01/31'],
            fee: 1000,
            carType: 'TOYOTA',
            carNo: 'XXX-888',
            engineNo: '12345678',
            licenseDate: '105/05/15'
        }
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const cathayFire = {
    body: [
        {
            add_prem: 1893,
            addr_id: 1,
            address: "臺北市大安區仁愛路四",
            ag_unit: "AH44F  ",
            agent_id: "C10797445C",
            ceapcid: "A10674832J",
            ceapcnm: "李○雄",
            ceisdnm: "周○雄",
            ceisdno: "A10674832J",
            celpsdt: "2019-11-30",
            ceplcdt: "2017-11-30",
            ceplcno: "151606RC101219",
            cepln: "FF02002   ",
            cepln_nm: "國泰產險住家綜合保險 ",
            cepoldt: "2017-11-30",
            oceisdno: "A10674832J",
            premium1: 1084,
            unit_name: "展信義四Ｆ"
        }
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const cathayCar = {
    body: [
        {
            ag_unit: "AH421  ",
            agent_id: "C18768708E",
            cartype: "C",
            ceisdnm: "廖○億",
            ceisdno: "C18768708E",
            celpsdt: "2018-02-25",
            ceplcdt: "2017-02-25",
            ceplcno: "151A17B103800       ",
            cepln: "TCH1      ",
            cepln_nm: "汽車險(強制險) ",
            cepoldt: "2016-12-05",
            displacement: 1600,
            lic_date: 10312,
            lic_no: "AJN-0311  ",
            oceisdno: "C18768708E",
            premium: 1138,
            ttitype: "TR1",
            unit_name: "展信義二１",
            update_time: "2018-02-16 23:58:16.650324",
            updater: "ABT2_9017 ",
            veh_name: "BIG Tiida 1.6S C12GHA A1-A 5D 5人座",
        },
        {
            ag_unit: "AH421  ",
            agent_id: "C18768708E",
            cartype: "C",
            ceisdnm: "廖○億",
            ceisdno: "C18768708E",
            celpsdt: "2019-04-15",
            ceplcdt: "2018-04-15",
            ceplcno: "151618B104847       ",
            cepln: "TCH1      ",
            cepln_nm: "汽車險(強制險)",
            cepoldt: "2018-04-15",
            displacement: 1600,
            lic_date: 10312,
            lic_no: "AJN-0311  ",
            oceisdno: "C18768708E",
            premium: 1099,
            ttitype: "TR1",
            unit_name: "展信義二１",
            update_time: "2018-11-23 23:58:37.806969",
            updater: "ABT2_9017 ",
            veh_name: "BIG Tiida 1.6S C12GHA A1-A 5D 5人座",
        },
        {
            ag_unit: "AH421  ",
            agent_id: "C18768708E",
            cartype: "M",
            ceisdnm: "廖○億",
            ceisdno: "C18768708E",
            celpsdt: "2019-08-04",
            ceplcdt: "2018-08-04",
            ceplcno: "151618G113489       ",
            cepln: "TCH2      ",
            cepln_nm: "機車險(強制險) ",
            cepoldt: "2018-08-03",
            displacement: 125,
            lic_date: 8511,
            lic_no: "AVG-976   ",
            oceisdno: "C18768708E",
            premium: 658,
            ttitype: "TR1",
            unit_name: "展信義二１",
            update_time: "2018-11-23 23:58:37.806969",
            updater: "ABT2_9017 ",
            veh_name: "YAMAHA山葉(國產)",
        },
    ],
    header: {
        message: "API Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const cathayTravel = {
    body: [
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "LD423  ",
            CEISDNM: "周○雄",
            CEISDNO: "A10674832J",
            CELPSDT: "2019-02-10",
            CEPLCDT: "2018-08-14",
            CEPLCNO: "150107TDA006954 ",
            CEPLN: "PC01009   ",
            CEPLN_NM: "國泰人壽搭售旅遊不便險專案    ",
            CEPOLDT: "2018-08-14",
            DIE_AMT: 0,
            INP_DAY: 0,
            INS_CNT: 1,
            OCEISDNO: "A10674832J",
            PREMIUM1: 866,
            PREMIUM2: 0,
            TRAVEL_AMT: 0,
            UNIT_NAME: "展大雅二３"
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "AH421  ",
            CEISDNM: "蘇○瑜",
            CEISDNO: "C10797445C",
            CELPSDT: "2018-11-13",
            CEPLCDT: "2018-11-06",
            CEPLCNO: "151607TDC14621 ",
            CEPLN: "PC01002   ",
            CEPLN_NM: "旅綜險(國外)",
            CEPOLDT: "2018-11-05",
            DIE_AMT: 300,
            INP_DAY: 10,
            INS_CNT: 1,
            OCEISDNO: "C10797445C",
            PREMIUM1: 387,
            PREMIUM2: 0,
            TRAVEL_AMT: 20,
            UNIT_NAME: "展信義二１"
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "YQ113  ",
            CEISDNM: "周○雄",
            CEISDNO: "A10674832J",
            CELPSDT: "2019-02-10",
            CEPLCDT: "2018-08-14",
            CEPLCNO: "151A07TDC09475",
            CEPLN: "PC01002   ",
            CEPLN_NM: "旅綜險(國外)",
            CEPOLDT: "2018-08-13",
            DIE_AMT: 100,
            INP_DAY: 0,
            INS_CNT: 1,
            OCEISDNO: "A10674832J",
            PREMIUM1: 998,
            PREMIUM2: 0,
            TRAVEL_AMT: 0,
            UNIT_NAME: "專北城益銓"
        },
    ],
    header: {
        message: "API Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const otherNewInsure = {
    body: [
        {
            no: '159D07HPA00026',
            name: '個人傷害險',
            company: '富邦產物保險公司',
            target: '陳怡君',
            startAt: '107/01/29',
            years: '1',
            fee: 2000,
            money: 200
        }
    ],
    header: {
        message: "↵Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const cathayNewInsure = {
    body: [
        {
            AGENT_ID: "C18768708E",
            AG_UNIT: "61A03AC",
            CEISDNM: "廖○億 明賢行",
            CEISDNO: "C18768708E",
            CELPSDT: "2019-06-27",
            CEPLCDT: "2018-06-27",
            CEPLCNO: "150107EC50012",
            CEPLN: "NL01      ",
            CEPLN_NM: "業主補償契約責任保險 ",
            CEPOLDT: "2018-06-04",
            OCEISDNO: "C18768708E",
            PLN5: "N59       ",
            PLN5_NM: "業主補償契約責任保險",
            PREMIUM1: 1050,
            PREMIUM2: 1050,
            UNIT_NAME: "展一部業三科轄區組"
        },
        {
            AGENT_ID: "C18768708E",
            AG_UNIT: "CFA0000",
            CEISDNM: "廖○億",
            CEISDNO: "C18768708E",
            CELPSDT: "2019-12-22",
            CEPLCDT: "2018-12-22",
            CEPLCNO: "150307PL52095",
            CEPLN: "NL01      ",
            CEPLN_NM: "公共意外責任保險",
            CEPOLDT: "2018-12-22",
            OCEISDNO: "C18768708E",
            PLN5: "N01       ",
            PLN5_NM: "公共意外責任險",
            PREMIUM1: 2110,
            PREMIUM2: 2110,
            UNIT_NAME: "台東通訊處"
        },
        {
            AGENT_ID: "C18768708E",
            AG_UNIT: "AFA000B",
            CEISDNM: "廖○億",
            CEISDNO: "C18768708E",
            CELPSDT: "2019-06-01",
            CEPLCDT: "2018-06-01",
            CEPLCNO: "150107MP01066",
            CEPLN: "NL03      ",
            CEPLN_NM: "商業動產流動保險 ",
            CEPOLDT: "2018-05-31",
            OCEISDNO: "C18768708E",
            PLN5: "NU4       ",
            PLN5_NM: "商業動產流動保險 ",
            PREMIUM1: 2000,
            PREMIUM2: 2000,
            UNIT_NAME: "松泰營業組"
        },
        {
            AGENT_ID: "C18768708E",
            AG_UNIT: "61A030A",
            CEISDNM: "廖○億",
            CEISDNO: "C18768708E",
            CELPSDT: "2019-11-26",
            CEPLCDT: "2018-11-26",
            CEPLCNO: "150107PD01580       ",
            CEPLN: "NL01      ",
            CEPLN_NM: "產品責任保險 ",
            CEPOLDT: "2018-11-22",
            OCEISDNO: "C18768708E",
            PLN5: "N08       ",
            PLN5_NM: "產品責任險",
            PREMIUM1: 2000,
            PREMIUM2: 2000,
            UNIT_NAME: "展發營業組"
        },
        {
            AGENT_ID: "C18768708E",
            AG_UNIT: "16A0400",
            CEISDNM: "廖○億及其主次承包商",
            CEISDNO: "C18768708E",
            CELPSDT: "2019-06-22",
            CEPLCDT: "2018-06-22",
            CEPLCNO: "150107CL01055       ",
            CEPLN: "NL01      ",
            CEPLN_NM: "營繕承包人意外責任保險",
            CEPOLDT: "2018-06-22",
            OCEISDNO: "C18768708E",
            PLN5: "N07       ",
            PLN5_NM: "營繕承包人意外責任",
            PREMIUM1: 2000,
            PREMIUM2: 2000,
            UNIT_NAME: "意外保險部責任保險科"
        },
        {
            AGENT_ID: "C18768708E",
            AG_UNIT: "61A03AC",
            CEISDNM: "廖○億",
            CEISDNO: "C18768708E",
            CELPSDT: "2019-12-07",
            CEPLCDT: "2018-12-07",
            CEPLCNO: "150107GL01018       ",
            CEPLN: "NL01      ",
            CEPLN_NM: "高爾夫球員綜合保險",
            CEPOLDT: "2018-11-14",
            OCEISDNO: "C18768708E",
            PLN5: "N02       ",
            PLN5_NM: "高爾夫球員責任險 ",
            PREMIUM1: 2552,
            PREMIUM2: 2552,
            UNIT_NAME: "展一部業三科轄區組"
        }
    ],
    header: {
        message: "API Success",
        status: "200",
        userDeviceIp: "1.2.3.4",
        userId: "C18768708E"
    }
}

export const cathayHarm = {
    body: [
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "HD112  ",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEBIRTH: "1958-05-25",
            CEISDNM: "周○雄",
            CEISDNO: "A10674832J",
            CELPSDT: "2021-04-24",
            CEPLCDT: "2018-04-24",
            CEPLCNO: "159507PAT00001",
            CEPLN: "PP03      ",
            CEPLN_NM: "三年期傷害險    ",
            CEPOLDT: "2018-05-07",
            OCEISDNO: "H20774254N",
            PREMIUM1: 4872,
            PREMIUM2: 4872,
            UNIT_NAME: "專吉利利欣"
        },
        {
            AGENT_ID: "A22230373O",
            AG_UNIT: "HA48C  ",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEBIRTH: "1961-06-20",
            CEISDNM: "周○雄",
            CEISDNO: "A10674832J",
            CELPSDT: "2019-12-09",
            CEPLCDT: "2018-12-09",
            CEPLCNO: "159D07PAD00639      ",
            CEPLN: "PP01      ",
            CEPLN_NM: "個人傷害險  ",
            CEPOLDT: "2018-12-07",
            OCEISDNO: "Q14090875L",
            PREMIUM1: 7219,
            PREMIUM2: 7219,
            UNIT_NAME: "展桃市八Ｃ"
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "HC415  ",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEBIRTH: "1980-01-13",
            CEISDNM: "周○雄",
            CEISDNO: "A10674832J",
            CELPSDT: "2019-08-16",
            CEPLCDT: "2018-08-16",
            CEPLCNO: "159D07PAC00775      ",
            CEPLN: "PP02      ",
            CEPLN_NM: "個人責任險 ",
            CEPOLDT: "2018-08-15",
            OCEISDNO: "Q17858016J",
            PREMIUM1: 1989,
            PREMIUM2: 1989,
            UNIT_NAME: "展八德一５"
        },
        {
            AGENT_ID: "A22230373O",
            AG_UNIT: "F5106  ",
            CEAPCNM: "美仕○店",
            CEAPCNO: "99999999  ",
            CEBIRTH: "1993-07-25",
            CEISDNM: "周○雄",
            CEISDNO: "A10674832J",
            CELPSDT: "2019-03-23",
            CEPLCDT: "2018-03-23",
            CEPLCNO: "151607PAG00756 ",
            CEPLN: "PG01 ",
            CEPLN_NM: "團體傷害險",
            CEPOLDT: "2018-03-23",
            OCEISDNO: "N28202934P",
            PREMIUM1: 716,
            PREMIUM2: 109217,
            UNIT_NAME: "專東冠冠晨"            
        }
    ],
    header: {
        message: "API Success",
        status: "200",
        userDeviceIp: "1.2.3.4",
        userId: "C18768708E"
    }
}

export const cathayHealth = {
    body: [
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "BDA0000",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEISDNM: "周○雄",
            CEISDNO: "A18817186J",
            CELPSDT: "2019-02-01",
            CEPLCDT: "2018-02-01",
            CEPLCNO: "157906HHA00082      ",
            CEPLN: "HHA       ",
            CEPLN_NM: "【個人住院醫療費用保險】                          ",
            CEPOLDT: "2017-12-28",
            OCEAPCNO: "A18817186J",
            OCEISDNO: "A18817186J",
            PREMIUM1: 5859,
            PREMIUM2: 5859,
            TYPE11: 0,
            TYPE41: 1000,
            TYPE42: 0,
            TYPE43: 0,
            TYPE44: 0,
            TYPE45: 0,
            TYPE51: 100000,
            TYPE61: 50000,
            UNIT_NAME: "嘉義通訊處"
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "AFA000B",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEISDNM: "周○雄",
            CEISDNO: "A18817186J",
            CELPSDT: "2020-01-15",
            CEPLCDT: "2019-01-15",
            CEPLCNO: "151508HHA30003",
            CEPLN: "HHA       ",
            CEPLN_NM: "個人健康保險－真愛無礙 安心防癌",
            CEPOLDT: "2019-01-11",
            OCEAPCNO: "A18817186J",
            OCEISDNO: "A18817186J",
            PREMIUM1: 8460,
            PREMIUM2: 8460,
            TYPE11: 0,
            TYPE41: 2000,
            TYPE42: 0,
            TYPE43: 0,
            TYPE44: 0,
            TYPE45: 0,
            TYPE51: 0,
            TYPE61: 1000000,
            UNIT_NAME: "松泰營業組"
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "FG455  ",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEISDNM: "周○雄",
            CEISDNO: "A18817186J",
            CELPSDT: "2019-02-26",
            CEPLCDT: "2018-02-26",
            CEPLCNO: "159606HHA00053      ",
            CEPLN: "HHA       ",
            CEPLN_NM: "個人健康保險－世紀防癌 ",
            CEPOLDT: "2017-12-27",
            OCEAPCNO: "A18817186J",
            OCEISDNO: "A18817186J",
            PREMIUM1: 1798,
            PREMIUM2: 1798,
            TYPE11: 0,
            TYPE41: 0,
            TYPE42: 0,
            TYPE43: 0,
            TYPE44: 0,
            TYPE45: 0,
            TYPE51: 0,
            TYPE61: 1500000,
            UNIT_NAME: "展中和五５",
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "AJA0000",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEISDNM: "周○雄",
            CEISDNO: "A18817186J",
            CELPSDT: "2020-01-15",
            CEPLCDT: "2019-01-15",
            CEPLCNO: "59108HPA30018       ",
            CEPLN: "HPA       ",
            CEPLN_NM: "個人突發傷病保險－金添保專案  ",
            CEPOLDT: "2019-01-11",
            OCEAPCNO: "A18817186J",
            OCEISDNO: "A18817186J",
            PREMIUM1: 2420,
            PREMIUM2: 2420,
            TYPE11: 0,
            TYPE41: 0,
            TYPE42: 0,
            TYPE43: 0,
            TYPE44: 0,
            TYPE45: 0,
            TYPE51: 0,
            TYPE61: 0,
            UNIT_NAME: "花蓮通訊處"
        },
        {
            AGENT_ID: "C10797445C",
            AG_UNIT: "HD199  ",
            CEAPCNM: "周○雄",
            CEAPCNO: "A18817186J",
            CEISDNM: "周○雄",
            CEISDNO: "A18817186J",
            CELPSDT: "2019-10-07",
            CEPLCDT: "2018-10-07",
            CEPLCNO: "159507HPA00206 ",
            CEPLN: "HPA       ",
            CEPLN_NM: "個人傷害(健康)保險－新世紀三保 ",
            CEPOLDT: "2018-10-04",
            OCEAPCNO: "A18817186J",
            OCEISDNO: "A18817186J",
            PREMIUM1: 2708,
            PREMIUM2: 2708,
            TYPE11: 0,
            TYPE41: 0,
            TYPE42: 0,
            TYPE43: 0,
            TYPE44: 0,
            TYPE45: 0,
            TYPE51: 0,
            TYPE61: 0,
            UNIT_NAME: "專吉利吉利"
        },
    ],
    header: {
        message: "↵Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const cathayAccident = {
    body: {
        TravelPolicy: [
            {
                APC_GRP: "國○人壽保險股份有限公司",
                APC_NAME: "",
                APLY_NO: "0093376810",
                Detail: {
                    POLICY_NO: "7111077384",
                    TOT_PREM: "10425元",
                },
                EFT_CODE_NM: "--",
                END_DATE: "2019-05-14",
                INSD_NAME: "陳○苗",
                ISSUE_DATE: "2019-05-08",
                ISSUE_NUM: "45",
                IS_A123: "N",
                PAY_FREQ_NM: "月繳",
                POLICY_NO: "7111079350",
                RENEW_YEAR: "0",
                RGN_CODE_NM: "其他夏威夷",
                TOT_HD_AMT: "53400萬",
                TOT_PREM: "58029",
            },
            {
                APC_GRP: "國○人壽保險股份有限公司",
                APC_NAME: "",
                APLY_NO: "0093223010",
                Detail: {
                    POLICY_NO: "7111077384",
                    TOT_PREM: "10425元",
                },
                EFT_CODE_NM: "--",
                END_DATE: "2019-05-03",
                INSD_NAME: "陳○苗",
                ISSUE_DATE: "2019-05-02",
                ISSUE_NUM: "75",
                IS_A123: "N",
                PAY_FREQ_NM: "月繳",
                POLICY_NO: "7111077384",
                RENEW_YEAR: "0",
                RGN_CODE_NM: "國內",
                TOT_HD_AMT: "30000萬",
                TOT_PREM: "10425",
            },
            {
                APC_GRP: "",
                APC_NAME: "陳○苗",
                APLY_NO: "0088670990",
                Detail: {
                    POLICY_NO: "7111006328",
                    TOT_PREM: "655元",
                },
                EFT_CODE_NM: "--",
                END_DATE: "2019-02-10",
                INSD_NAME: "黃○剛",
                ISSUE_DATE: "2019-02-05",
                ISSUE_NUM: "5",
                IS_A123: "N",
                PAY_FREQ_NM: "年繳",
                POLICY_NO: "7111006328",
                RENEW_YEAR: "0",
                RGN_CODE_NM: "國內",
                TOT_HD_AMT: "1000萬",
                TOT_PREM: "655",
            },
        ]
    },
    header: {
        message: "↵Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const cathayGroup = {
    body: [
        {
            no: 'G000018991',
            target: '陳怡君',
            members: 2,
            client: '圈圈叉叉股份有限公司',
            role: '本人',
            level: '04',
            duration: ['107/01/31', '108/01/31'],
        }
    ],
    header: {
        message: "↵Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
      
}

export const record = {
    body: {
        detail: []
    },
    header: {
        message: "↵Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const getFamilInsertList = {
    body: {
        familymemberlist: [
            {
                birthday: "1965-06-19",
                name: "何○香",
                personalid: "T28608199F",
            },
            {
                birthday: "1921-02-01",
                name: "94N",
                personalid: "H122368161",
            },
            {
                birthday: "",
                name: "ACCSSSSS",
                personalid: "1234567890",
            },
            {
                birthday: "1965-09-25",
                name: "侯○卿",
                personalid: "Q28788137A",
            },
            {
                birthday: "1978-08-26",
                name: "劉○伸",
                personalid: "F18016547B",
            },
            {
                birthday: "1961-09-11",
                name: "劉○婷",
                personalid: "F28827296G",
            },
        ]
    },
    header: {
        message: "↵Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const familyMember = {
    body: {
        familymembers: [
            {
                birthday: "55/8/6",
                guid: "61dfacfadf414c8694cedbdd7e7e7610",
                householderid: "C18768708E",
                name: "袁○倫",
                personalid: "A18656110F",
                relation: "3",
                sex: "1",
            },
            {
                birthday: "68/4/20",
                guid: "cde81e7583e5477598216f0341b7342f",
                householderid: "C18768708E",
                name: "蘇○瑜",
                personalid: "D28782340D",
                relation: "2",
                sex: "2",
            },
            {
                birthday: "99/5/20",
                guid: "4ec60595ad4b469c94967be0b5281d2d",
                householderid: "C18768708E",
                name: "廖○億",
                personalid: "C18768708E",
                relation: "0",
                sex: "1",
            },
            {
                birthday: "53/2/2",
                guid: "0e764d03257146578414dbf3a467379f",
                householderid: "C18768708E",
                name: "劉○妤",
                personalid: "N28876072F",
                relation: "4",
                sex: "2",
            },
        ]
    },
    header: {
        message: "↵Success",
        status: "200",
    }
}

export const group = {
    body: {
        groups: [
            {grp_name: "顏金源", grp_id: "002"},
            {grp_name: "顏素琴", grp_id: "003"},
            {grp_name: "王美珠", grp_id: "005"},
            {grp_name: "蘇瑋晴", grp_id: "006"},
            {grp_name: "沈慶豐", grp_id: "008"},
            {grp_name: "沈淑媛", grp_id: "012"},
            {grp_name: "沈有義", grp_id: "014"},
            {grp_name: "孫榮隆", grp_id: "015"},
            {grp_name: "陳美華", grp_id: "016"},
            {grp_name: "高秀蓮", grp_id: "017"},
            {grp_name: "溫國樟", grp_id: "018"},
            {grp_name: "袁明   ", grp_id: "019"},
            {grp_name: "陳美維", grp_id: "021"},
            {grp_name: "黃淑慎", grp_id: "022"},
            {grp_name: "孫百弘", grp_id: "024"},
            {grp_name: "利得儀器", grp_id: "025"},
            {grp_name: "王美玲", grp_id: "027"},
            {grp_name: "何敏香", grp_id: "028"},
            {grp_name: "胡青青", grp_id: "029"},
            {grp_name: "房地合一", grp_id: "030"},
            {grp_name: "信用卡群組", grp_id: "031"},
            {grp_name: "新群組787546", grp_id: "077"},
            {grp_name: "測試群組106", grp_id: "034"},
            {grp_name: "好棒棒", grp_id: "078"},
            {grp_name: "測試群組67", grp_id: "035"},
            {grp_name: "新群組", grp_id: "036"},
            {grp_name: "袁明", grp_id: "032"},
            {grp_name: "測試群組318", grp_id: "079"},
            {grp_name: "測試for條件篩選", grp_id: "080"},
            {grp_name: "測試李家群組", grp_id: "081"}
        ]
    }
}

export const custInfo = {
    body: {
        customer: {
            age: 41,
            birthday: "1978-03-16",
            corp: "展○義",
            corp_addr1: "台北市",
            corp_addr2: "大安區",
            corp_addr3: "仁愛路0段000號0樓",
            corp_addr_zip: "106",
            corp_tel: "27***431",
            corp_tel_area: "02",
            corp_tel_ext: "",
            edu: "4",
            email: "liao316@cathaylifetest.com.tw",
            fax: "",
            fax_area: "",
            home_addr1: "台北市",
            home_addr2: "松山區",
            home_addr3: "健康路000巷00弄0號0樓",
            home_addr_zip: "105",
            home_tel: "",
            home_tel_area: "",
            id: "C18768708E",
            idmark: {
                source1: "1",
                source2: "1",
                source3: "1",
                source4: "0",
                source5: "1",
                source6: "1",
            },
            introducer: "",
            introducer_name: "",
            job: "9",
            lineid: "",
            marry: "1",
            mobile: "0910***722",
            name: "廖○億",
            relation: {
                source1: "1",
                source1_pltn: "3",
                source2: "0",
                source3: "1",
                source4: "1",
                source5: "0",
                source6: "1",
            },
            sex: "1",
        },
        financial: {
            car: "2",
            family_incom: "3",
            finance: "000000000",
            house: "3",
            incommy: "1",
            invest: "4",
            loan_amt: 0,
        },
        refuse_mark: {
            agnt_promote: "",
            email_promote: "",
            mail_promote: "",
            phone_promote: "",
            sms_promote: "",
            stop_personal_data: "",
        },
        service_check: {
            annuity: [
                {
                    amt: 40000,
                    bank_sname: "",
                    cebnfnm: "",
                    curr: "台幣",
                    pay_date: "107/10/24",
                    plcno: "7208020786",
                },
            ],
            changeonline: "Y",
            claim_offset_bill: "已辦理",
            csemail: [
                {

                },
                {
                    
                },
            ],
            ecall: [],
            eserver: "已辦理",
            matag: [],
            payment_apply: [
                {

                },
                {
                    
                },
            ],
            pl_loan: [
                {
                    avlamt: "39300",
                    int_end_date: "1998-10-25",
                    plan_name: "美滿人生321終生",
                    plcno: "5560433737",
                    rate: "6.90000",
                    useamt: "0", 
                },
                {
                    avlamt: "39300",
                    int_end_date: "1998-10-25",
                    plan_name: "美滿人生321終生",
                    plcno: "5560433737",
                    rate: "6.90000",
                    useamt: "0", 
                },
            ],
            plcnos: [
                {

                },
                {
                    
                },
            ],
            show_claim_offset_bill: "已辦理",
            show_ecall: "詳細資訊",
        }
    },
    header: {
        status:'200'
    }
}

export const customers = {
    body: {
        customer_list: [
            {
                birthday: "1960-10-08",
                id: "L01750386I",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "1", source1: "1"},
                index: "17",
                mobile: "",
                name: "許○雅",
                sex: "2",
            }, {
                birthday: "1951-01-03",
                id: "A02627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A03810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, 
            {
                birthday: "1935-12-23",
                id: "E04790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H05634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A06915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A07627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, 
            {
                birthday: "1943-02-05",
                id: "A08810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E09790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H10634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A11915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A12627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A13810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E14790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H15634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A16915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A17627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A18810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E19790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H20634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A21915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A22627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A23810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E24790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H25634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A26915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A27627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A28810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E29790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H30634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A31915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A32627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A33810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E34790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H35634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A36915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A37627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A38810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E39790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H40634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A41915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A42627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A43810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E44790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H45634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A46915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            },{
                birthday: "1951-01-03",
                id: "A47627695G",
                idmark: {source3: "0", source4: "0", source5: "0", source6: "0", source1: "1"},
                index: "1",
                mobile: "",
                name: "張王○淑",
                sex: "2",
            }, {
                birthday: "1943-02-05",
                id: "A48810466I",
                idmark: {},
                index: "2",
                mobile: "",
                name: "林王○美",
                sex: "2",
            }, {
                birthday: "1935-12-23",
                id: "E49790558F",
                idmark: {},
                index: "3",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1960-09-13",
                id: "H50634455A",
                idmark: {},
                index: "4",
                mobile: "",
                name: "王○",
                sex: "2",
            }, {
                birthday: "1943-01-01",
                id: "A51915683D",
                idmark: {},
                index: "5",
                mobile: "",
                name: "王○一",
                sex: "1",
            }
        ],
        page: "1",
        rows: "200",
        totalcusts: "1611",
        totalpages: "9"
    },
    header: {
    message: "成功",
    status: "200",
    userDeviceIp: "10.87.23.53",
    userId: "C18768708E",
    }
}

export const loginUser = {
    header: {userDeviceIp: "1.2.3.4"},
    body: {
        user: [{
            code_name: "code_name",
            div_no: "AH42100",
            div_short_name: "展信義二１",
            id: "C18768708E",
            mkt_dept_name: "展業北三區",
            mkt_dept_no: "AC00000",
            name: "廖○億",
            position: "position",
            workDate: "10804工 第2天"
        }]
    }
}

export const shareVideo = {
    body: {dataList: {record: [
        {
            cover: "https://img.youtube.com/vi/ETMPuyrZdp0/hqdefault.jpg",
            link: "https://www.youtube.com/watch?v=ETMPuyrZdp0",
            title: "好康標題5"
        },
        {
            cover: "https://img.youtube.com/vi/ETMPuyrZdp0/hqdefault.jpg",
            link: "https://www.youtube.com/watch?v=ETMPuyrZdp0",
            title: "好康標題5"
        },
        {
            cover: "https://img.youtube.com/vi/ETMPuyrZdp0/hqdefault.jpg",
            link: "https://www.youtube.com/watch?v=ETMPuyrZdp0",
            title: "好康標題5"
        }
    ]}},
    header: {
        message: "FILTERCUSTOMER_API : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    },

}

export const news = {
    body: {
        news: [
            {
                STAR_DATE: "2019-01-04 12:50:51.0",
                author: "申請單位名稱8",
                link: "https://www.google.com.tw/",
                linkType: "web",
                publishAt: "01/04",
                title: "我是新聞標題8"
            },
            {
                STAR_DATE: "2019-01-04 12:50:51.0",
                author: "申請單位名稱8",
                link: "https://www.google.com.tw/",
                linkType: "web",
                publishAt: "01/04",
                title: "我是新聞標題7"
            },
            {
                STAR_DATE: "2019-01-04 12:50:51.0",
                author: "申請單位名稱8",
                link: "https://www.google.com.tw/",
                linkType: "web",
                publishAt: "01/04",
                title: "我是新聞標題6"
            },
            {
                STAR_DATE: "2019-01-04 12:50:51.0",
                author: "申請單位名稱8",
                link: "https://www.google.com.tw/",
                linkType: "web",
                publishAt: "01/04",
                title: "我是新聞標題5"
            },
            {
                STAR_DATE: "2019-01-04 12:50:51.0",
                author: "申請單位名稱8",
                link: "https://www.google.com.tw/",
                linkType: "web",
                publishAt: "01/04",
                title: "我是新聞標題4"
            }
        ],
    },
    header:{
        message: "SERVICE_API:借款人ID不可為空",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const getSearchRecord = {
    body: {
        record_list: [
            {
                agnt_id: "C18768708E",
                field_name: "idage",
                option: "min:20/max:29",
                option_ch: "年齡:20歲~29歲",
                searchtime: "2019-04-25 13:38:19.0",
                status: "S",
            },
            {
                agnt_id: "C18768708E",
                field_name: "incomy",
                option: "3/4/5/6",
                option_ch: "個人年所得:30萬以上",
                searchtime: "2019-04-25 11:25:37.0",
                status: "S",
            },
            {
                agnt_id: "C18768708E",
                field_name: "idage-incomy",
                option: "min:1/max:99-2",
                option_ch: "年齡:1歲~99歲;個人年所得:未滿30萬",
                searchtime: "2019-04-25 11:24:17.0",
                status: "S",
            },
        ]
    },
    header:{
        message: "FILTERCUSTOMER_API : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const getSearchFavorite = {
    body:{
        record_list:[
            {
                agnt_id: "C18768708E",
                favorite_name: "天馬行空",
                field_name: "idage-sex-matage_month-birthmonth-incomy",
                option: "min:20/max:66-2-nextmonth-3-2",
                option_ch: "年齡:20歲~66歲;性別:女;滿期金即將給付月份:下個月;生日月份:三月;個人年所得:未滿30萬",
                searchtime: "2019-04-25 16:09:26.0",
                status: "F",
            },
            {
                agnt_id: "C18768708E",
                favorite_name: "test06",
                field_name: "idage-job",
                option: "min:40/max:49-21",
                option_ch: "年齡:40歲~49歲;職業:律師、醫師、會計師、建築師、引水人",
                searchtime: "2019-04-25 11:20:13.0",
                status: "F",
            },
            {
                agnt_id: "C18768708E",
                favorite_name: "test01",
                field_name: "idage-sex-birthmonth",
                option: "min:25/max:33-2-2",
                option_ch: "年齡:25歲~33歲;性別:女;生日月份:二月",
                searchtime: "2019-04-24 17:48:04.0",
                status: "F",
            },
        ]
    },
    header:{
        message: "FILTERCUSTOMER_API : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const queryHousingLoans = {
    body:[],
    header:{
        message: "SERVICE_API:借款人ID不可為空",
        status: "400",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const getCustIAA = {
    body:{
        check_item:{},
        detail:{
            addr_newest_city_nm: "",
            addr_newest_line_1: "",
            addr_newest_line_2: "",
            addr_newest_postal_cd: "",
            addr_newest_update: "",
            email: "",
            email_update: "",
            mobile01: "0911123456",
            mobile01_update: "2019-05-07 00:00:00.0",
            mobile02: "",
            mobile02_update: "",
            party_id: "C18768708E",
            tel_newest: "",
            tel_newest_area: "",
            tel_newest_ext: "",
            tel_newest_update: "",
        },
        returnCode: "0000",
        returnMsg: "",
    },
    header:{
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const getSearchFilter = {
    body:{
        conditions_list:[
            {
                field_description: "年齡",
                field_name: "idage",
                name: "未滿15歲",
                option: "max:14",
                ser_no: 1,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "15歲以上",
                option: "min:15",
                ser_no: 2,
            },
            {
                field_description: "年齡",
                field_name: "idage",
                name: "自設年齡區間",
                option: "setbyuser",
                ser_no: 3,
            },
            {
                field_description: "增齡月份",
                field_name: "agemonth",
                name: "本月",
                option: "thismonth",
                ser_no: 1,
            },
            {
                field_description: "增齡月份",
                field_name: "agemonth",
                name: "下個月",
                option: "nextmonth",
                ser_no: 2,
            },
            {
                field_description:"年金即將給付月份",
                field_name:"annuity_month",
                name:"本月",
                option:"thismonth",
                ser_no:1,
            },
            {
                field_description:"年金即將給付月份",
                field_name:"annuity_month",
                name:"下個月",
                option:"nextmonth",
                ser_no:2,
            },
            {
                field_description:"生日月份",
                field_name:"birthmonth",
                name:"一月",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"生日月份",
                field_name:"birthmonth",
                name:"二月",
                option:"2",
                ser_no:2,

            },
            {
                field_description:"生日月份",
                field_name:"birthmonth",
                name:"三月",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"交通工具",
                field_name:"car",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"交通工具",
                field_name:"car",
                name:"機車與汽車",
                option:"4",
                ser_no:4,

            },
            {
                field_description:"交通工具",
                field_name:"car",
                name:"機車",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"理賠抵繳",
                field_name:"claimoffset",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"理賠抵繳",
                field_name:"claimoffset",
                name:"已申辦",
                option:"1",
                ser_no:2,

            },
            {
                field_description:"客戶關係",
                field_name:"custrl",
                name:"經手件",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"客戶關係",
                field_name:"custrl",
                name:"服務件",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"易Call保",
                field_name:"ecall",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"易Call保",
                field_name:"ecall",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"教育",
                field_name:"edu",
                name:"國中以下",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"教育",
                field_name:"edu",
                name:"高中/職",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"教育",
                field_name:"edu",
                name:"專科",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"電子單據",
                field_name:"email",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"電子單據",
                field_name:"email",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"家庭年所得",
                field_name:"family_incom",
                name:"未滿60萬",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"家庭年所得",
                field_name:"family_incom",
                name:"60萬以上",
                option:"2/3/4/5/6/7",
                ser_no:2,
            },
            {
                field_description:"理財工具",
                field_name:"finance",
                name:"定存",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"理財工具",
                field_name:"finance",
                name:"保險",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"理財工具",
                field_name:"finance",
                name:"其同基金",
                option:"3",
                ser_no:3,
            },
            {
                field_description:"住屋狀況",
                field_name:"house",
                name:"自有",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"住屋狀況",
                field_name:"house",
                name:"租賃",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"個人年所得",
                field_name:"incomy",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"個人年所得",
                field_name:"incomy",
                name:"未滿30萬",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"個人年所得",
                field_name:"incomy",
                name:"30萬以上",
                option:"3/4/5/6",
                ser_no:3,
            },
            {
                field_description:"月平均投資",
                field_name:"invest",
                name:"無",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"月平均投資",
                field_name:"invest",
                name:"未滿3000",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"月平均投資",
                field_name:"invest",
                name:"3000以上",
                option:"3/4/5/6/7",
                ser_no:3,
            },
            {
                field_description:"職業",
                field_name:"job",
                name:"農業",
                option:"01",
                ser_no:1,
            },
            {
                field_description:"職業",
                field_name:"job",
                name:"林業",
                option:"02",
                ser_no:2,
            },
            {
                field_description:"職業",
                field_name:"job",
                name:"漁業",
                option:"03",
                ser_no:3,
            },
            {
                field_description:"婚姻",
                field_name:"marry",
                name:"未婚",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"婚姻",
                field_name:"marry",
                name:"已婚",
                option:"2",
                ser_no:2,
            },
            {
                field_description:"滿期金即將給付月份",
                field_name:"matag_month",
                name:"本月",
                option:"thismonth",
                ser_no:1,
            },
            {
                field_description:"滿期金即將給付月份",
                field_name:"matag_month",
                name:"下個月",
                option:"nextmonth",
                ser_no:2,
            },
            {
                field_description:"行動服務",
                field_name:"mobile",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"行動服務",
                field_name:"mobile",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"網路服務線上變更",
                field_name:"online",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"網路服務線上變更",
                field_name:"online",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"ID一指通",
                field_name:"payment",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"ID一指通",
                field_name:"payment",
                name:"已申辦",
                option:"1",
                ser_no:2,
            },
            {
                field_description:"意外險續保月份",
                field_name:"pla1_month",
                name:"本月",
                option:"thismonth",
                ser_no:1,
            },
            {
                field_description:"意外險續保月份",
                field_name:"pla1_month",
                name:"下個月",
                option:"nextmonth",
                ser_no:2,
            },
            {
                field_description:"車險續保月份",
                field_name:"plc1_month",
                name:"本月",
                option:"thismonth",
                ser_no:1,
            },
            {
                field_description:"車險續保月份",
                field_name:"plc1_month",
                name:"下個月",
                option:"nextmonth",
                ser_no:2,
            },
            {
                field_description:"火險續保月份",
                field_name:"plf1_month",
                name:"本月",
                option:"thismonth",
                ser_no:1,
            },
            {
                field_description:"火險續保月份",
                field_name:"plf1_month",
                name:"下個月",
                option:"nextmonth",
                ser_no:2,       
            },
            {
                field_description:"保單貸款",
                field_name:"policy_loan",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"保單貸款",
                field_name:"policy_loan",
                name:"已申辦",
                option:"1",
                ser_no:2,    
            },
            {
                field_description:"性別",
                field_name:"sex",
                name:"男",
                option:"1",
                ser_no:1,
            },
            {
                field_description:"性別",
                field_name:"sex",
                name:"女",
                option:"2",
                ser_no:2, 
            },
            {
                field_description:"轉帳申請",
                field_name:"trans_plpy",
                name:"未申辦",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"轉帳申請",
                field_name:"trans_plpy",
                name:"已申辦",
                option:"1",
                ser_no:2,              
            },
            {
                field_description:"公司網站會員",
                field_name:"web_member",
                name:"未開通",
                option:"0",
                ser_no:1,
            },
            {
                field_description:"公司網站會員",
                field_name:"web_member",
                name:"已開通",
                option:"1",
                ser_no:2,
            },
        ],
    },
    header:{
        message: "INITALPAGECONDITION_API : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const queryDistByCity = {
    body: {
        cityAreaList: [
            {
                AREA: "中壢區",
                CITY: "桃園市",
                ZIPCODE: "320",
            },
            {
                AREA: "平鎮區",
                CITY: "桃園市",
                ZIPCODE: "324", 
            },
            {
                AREA: "龍潭區",
                CITY: "桃園市",
                ZIPCODE: "325",
            },
            {
                AREA: "新屋區",
                CITY: "桃園市",
                ZIPCODE: "327",
            },
            {
                AREA: "桃園區",
                CITY: "桃園市",
                ZIPCODE: "330",
            },
            {
                AREA: "龜山區",
                CITY: "桃園市",
                ZIPCODE: "333",
            },
        ],
    },
    header: {
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const queryPlanCode = {
    body:{
        contract:[
            {PROD_ID: "CZ_", PROD_NM: "GO保障100定期壽險附約"},
            {PROD_ID: "CZ1_", PROD_NM: "GO保障100定期壽險附約"},
            {PROD_ID: "CU_", PROD_NM: "GO安心100美元定期壽險附約"},
            {PROD_ID: "DU_", PROD_NM: "Hen呵護長期照顧定期健康保險附約"},
            {PROD_ID: "DW_", PROD_NM: "Hen安全定期傷害保險附約"},
            {PROD_ID: "BW_", PROD_NM: "乖寶貝健康保險附約"},
            {PROD_ID: "9BS_", PROD_NM: "住院日額保險附約-10年退協"},
            {PROD_ID: "AY_", PROD_NM: "住院日額給付特約"},
            {PROD_ID: "A6_", PROD_NM: "住院醫療特約"},
            {PROD_ID: "WP2_", PROD_NM: "保險費豁免"},
        ]
    },
    header:{
        message: "DB_API: Success",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E",
    }
}

export const getGroupMember = [
    {
        AGE: 6,
        BIRTHDAY: "2013-08-21",
        GRP_ID: "001",
        HOME_TEL: "",
        HOME_TEL_AREA: "",
        ID: "A186198344",
        MOBILE: "0911223344",
        NAME: "吃吃合",
        PHONE: "-",
        SEX: "1",
        SOURCE1: "0",
        SOURCE2: "0",
        SOURCE3: "0",
        SOURCE4: "0",
        SOURCE5: "0",
        SOURCE6: "1",
        sourceFilter: ["6"],
    },
    {
        AGE: 4,
        BIRTHDAY: "2015-08-19",
        GRP_ID: "001",
        HOME_TEL: "25876978",
        HOME_TEL_AREA: "02",
        ID: "A178914745",
        MOBILE: "0987654321",
        NAME: "孫○哲",
        PHONE: "02-25876978",
        SEX: "1",
        SOURCE1: "0",
        SOURCE2: "0",
        SOURCE3: "0",
        SOURCE4: "0",
        SOURCE5: "0",
        SOURCE6: "1",
        sourceFilter: ["1","3","4","6"]
    },
]

export const queryMinorInsurDetail = {
    body:{
        rider_list:[
            {
                cs_name: "葉○卿",
                curr: "",
                eft_code_ch: "",
                id: "N26629287B",
                policy_no: "5530301356",
                product_link: "",
                rd_amt: "100",
                rd_amt_unit: "萬",
                rd_id: "AD",
                rd_name: "附加傷害保險給付特約（新）－家庭型",
                rd_prem: "3114",
                rd_prem_unit: "元",
                term_date: "2010-08-10",
            },
            {
                cs_name: "葉○卿",
                curr: "",
                eft_code_ch: "",
                id: "N26629287B",
                policy_no: "5530301356",
                product_link: "",
                rd_amt: "119",
                rd_amt_unit: "萬",
                rd_id: "AD2",
                rd_name: "附加傷害保險給付特約（新）－家庭型（１０７條調降）",
                rd_prem: "2650",
                rd_prem_unit: "元",
                term_date: "2021-08-11",
            },
            {
                cs_name: "葉○卿",
                curr: "",
                eft_code_ch: "",
                id: "N26629287B",
                policy_no: "5530301356",
                product_link: "",
                rd_amt: "1",
                rd_amt_unit: "單位",
                rd_id: "AM",
                rd_name: "防癌終身健康保險附約－個人型（８５年３月１５日以前）",
                rd_prem: "0",
                rd_prem_unit: "元",
                term_date: "保障終身",
            },
        ],
    },
    header:{
        message: "↵SERVICE_API: Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const queryPaymentMessage = {
    body:{
        PaymentDetail:{
            ACNT_CARD_NO: "",
            BANK_NAME: "",
            CURR: "NTD",
            MAIN_PREM: "0.0000",
            NXT_PAY_DATE: "2019-08-11",
            PAY_FREQ: "年繳",
            PAY_PRD: "15",
            PAY_TIMES: "60",
            PAY_WAY_CODE: "3",
            PREM_ADJ: "0.0000",
            PREM_DISC: "27.0000",
            PREM_RCPT: "2623.0000",
            PREM_RD: "2650.0000",
            RATE_DISC_H: "      ",
            RATE_DISC_W: "      ",
        },
        PaymentRecord:[
            {
                ACNT_NO_TRN: "4684",
                PAY_DATE_CLC: "2018-08-20",
                PAY_TIMES: "0",
                PAY_WAY_CODE: "轉帳",
                TOT_PREM: "2623.0000",
            },
            {
                ACNT_NO_TRN: "4684",
                PAY_DATE_CLC: "2017-08-21",
                PAY_TIMES: "0",
                PAY_WAY_CODE: "轉帳",
                TOT_PREM: "2623.0000",
            },
            {
                ACNT_NO_TRN: "4684",
                PAY_DATE_CLC: "2016-08-19",
                PAY_TIMES: "0",
                PAY_WAY_CODE: "轉帳",
                TOT_PREM: "2637.0000",
            },
        ],
    },
    header:{
        message: "SERVICE_API Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    }
}

export const getOutSegment = {
    body: {
        segment: [
            {
                c_qcount: 0,
                c_vcount: 0,
                code: "A",
                code_nm: "離職、退休人員",
                countcust: 505,
                countidno: 2,
                num: 1,
                qcount: 505,
                sort: "強制調撥",
                vcount: 10,
            },
            {
                c_qcount: 0,
                c_vcount: 0,
                code: "N0",
                code_nm: "全單位疏遠件",
                countcust: 1271,
                countidno: 75,
                num: 2,
                qcount: 0,
                sort: "強制調撥",
                vcount: 0,
            },
            {
                c_qcount: 0,
                c_vcount: 0,
                code: "AXCX",
                code_nm: "空區空股(含9A)",
                countcust: 6265,
                countidno: 16,
                num: 6,
                qcount: 0,
                sort: "建議調撥",
                vcount: 0,
            },
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getInSegment = {
    body: {
        segment: [
            {
                c_qcount: 0,
                c_vcount: 0,
                code: "E",
                code_nm: "2年內新人",
                countcust: 5194,
                countidno: 31,
                num: 1,
                qcount: 145,
                sort: "強制調撥",
                vcount: 0,
            },
            {
                c_qcount: 0,
                c_vcount: 0,
                code: "H",
                code_nm: "AFP&CFP人員",
                countcust: 244,
                countidno: 1,
                num: 2,
                qcount: 0,
                sort: "強制調撥",
                vcount: 0,
            },
            {
                c_qcount: 0,
                c_vcount: 0,
                code: "G",
                code_nm: "其他業務同仁",
                countcust: 24637,
                countidno: 93,
                num: 3,
                qcount: 0,
                sort: "建議調撥",
                vcount: 0,
            },
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getOutAgnClcNo = {
    body: {
        agents: [
            {
                agidno: "G18676124F",
                ceempnm: "張○祥",
                clcno: "AH5",
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                clcno: "AH521",
            },
            {
                agidno: "N26630132A",
                ceempnm: "洪○美",
                clcno: "AH52118",
            },
            {
                agidno: "A28693181E",
                ceempnm: "黃○美",
                clcno: "AH52163",
            },
            {
                agidno: "A26974319G",
                ceempnm: "曾許○珠",
                clcno: "AH52183",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
    },
}

export const getInAgnClcNo = {
    body: {
        agents: [
            {
                agidno: "G18676124F",
                ceempnm: "張○祥",
                clcno: "AH5",
            },
            {
                agidno: "A28631004I",
                ceempnm: "楊○苑",
                clcno: "AH52099",
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                clcno: "AH521", 
            },
            {
                agidno: "N26630132A",
                ceempnm: "洪○美",
                clcno: "AH52118",
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                clcno: "AH52119", 
            },
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
    },
}

export const getSegmentAgnt = {
    body: {
        agents: [
            {
                agidno: "A28693181E",
                ceempnm: "黃○美",
                clcno: "AH52163",
                code_nm: "108年全單位疏遠件 ",
                cs_count: 7,
            },
            {
                agidno: "A26974319G",
                ceempnm: "曾許○珠",
                clcno: "AH52183",
                code_nm: "108年全單位疏遠件 ",
                cs_count: 1, 
            },
            {
                agidno: "A18291939C",
                ceempnm: "沈○宇",
                clcno: "AH52185",
                code_nm: "108年全單位疏遠件 ",
                cs_count: 5,
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                clcno: "AH52197",
                code_nm: "108年全單位疏遠件 ",
                cs_count: 69,
            },
            {
                agidno: "G18676124F",
                ceempnm: "張○祥",
                clcno: "AH5",
                code_nm: "其他業務同仁",
            },
        ],
    },
    header: {
        message: "MXB1_1002 : Success.",
        status: "200",
    },
}


export const querySmartMappingData = {
    body: {
        smartpairdatalist: [
            {
                ceagent: "0",
                ceagnid: "S27963083O",
                ceagnnm: "郭O鳳",
                ceapcnm: "刁O豪",
                ceapcno: "F10418705X",
                ceclcar: "EZ11719",
                ceclcid: "M23125754N",
                ceclcid_new: "A29784655C",
                ceclcnm: "吳O玲",
                ceclcnm_new: "林O",
                ceclcno: "EZ11719",
                celpscs_nm: "終身險滿期",
                ceplcno: "0000020548",
                clcno_new: "EZ10249",
                cust_id: "F10418705X",
                d1_payaddr: "高雄市左營",
                d2_payaddr: "高雄市左營",
                deadline: "2023-08-30",
                jcode: "WU",
                jcode_new: "KZ",
                producer_segment: "ND",
                sum_ceplcno: 1,
                zip_code: "81366",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.61",
        userId: "E14035641A",
    },
}


export const checkInsByNo = {
    body: {
        detail: {ceplcno: "3760501319", isout: "0"},
        returncode: "0",
        returnmsg: "檢核正確",
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const checkInsById = {
    body: {
        detail: {ceplcno: "9177912287", isout: "0"},
        returncode: "0",
        returnmsg: "檢核正確",
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryCustListByCustomized = {
    body: {
        customer_list: [
            {
                address: "新北市中和區南山路000號00樓之0",
                birthday: "2004-05-20",
                id: "A29769455F",
                idage: 14,
                idmark: {
                    source1: "",
                    source2: "",
                    source3: "",
                    source4: "",
                    source5: "",
                    source6: "",
                },
                index: "1",
                mobile: "",
                name: "劉○彤",
                phone: "02-25***960",
                sex: "2",
            },
            {
                address: "新北市汐止區",
                birthday: "2006-05-05",
                id: "A23668562F",
                idage: 13,
                idmark: {
                    source1: "",
                    source2: "",
                    source3: "",
                    source4: "",
                    source5: "",
                    source6: "",
                },
                index: "2",
                mobile: "0915938526",
                name: "劉○霆",
                phone: "02-22004588",
                sex: "2",
            },
            {
                address: "",
                birthday: "2009-09-12",
                id: "C28730337A",
                idage: 10,
                idmark: {
                    source1: "",
                    source2: "",
                    source3: "",
                    source4: "",
                    source5: "",
                    source6: "",
                },
                index: "3",
                mobile: "",
                name: "卿○庭",
                phone: "",
                sex: "2",
            },
            {
                address: "",
                birthday: "2009-09-12",
                id: "C28730338J",
                idage: 10,
                idmark: {
                    source1: "",
                    source2: "",
                    source3: "",
                    source4: "",
                    source5: "",
                    source6: "",
                },
                index: "4",
                mobile: "",
                name: "卿○茜",
                phone: "",
                sex: "2",
            },
            {
                address: "",
                birthday: "1999-05-08",
                id: "A18524027I",
                idage: 19,
                idmark: {
                    source1: "",
                    source2: "",
                    source3: "",
                    source4: "",
                    source5: "",
                    source6: "",
                },
                index: "5",
                mobile: "",
                name: "吳○翰",
                phone: "",
                sex: "1",
            },
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryIAA = {
    body: {
        
    },
    header: {
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryIAACust = {
    body: {
        check_item: {},
        detail: {
            addr_newest_city_nm: "",
            addr_newest_line_1: "",
            addr_newest_line_2: "",
            addr_newest_postal_cd: "",
            addr_newest_update: "",
            email: "",
            email_update: "",
            mobile01: "0911123456",
            mobile01_update: "2019-05-07 00:00:00.0",
            mobile02: "",
            mobile02_update: "",
            party_id: "C18768708E",
            tel_newest: "",
            tel_newest_area: "",
            tel_newest_ext: "",
            tel_newest_update: "",
        },
        returnCode: "0000",
        returnMsg: "",
    },
    header: {
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addIAA_API = {
    body: {
        
    },
    header: {
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const updateIAA_API = {
    body: {
        
    },
    header: {
        message: "Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryNoteList = {
    body: {
        detail: [
            {
                EVENT_DATE: "108/03/18",
                EVENT_SER_NO: "19107",
                EVENT_TIME: "17:05",
                EVENT_YEAR: "2019",
                ISMISS: "N",
                NOTE_STRING: "測試更新拜訪記錄-筆記內容",
                RECORD_STRING: "測試更新拜訪記錄-日誌內容",
                RECORD_SYMBOL: "006",
                REFERRAL1: "",
                REFERRAL2: "",
                SUB_CLS_CODE: "A0105房貸,A0202資料收集,A0301壽險,A0404滿期金/年金,A0502OPP",
            },
            {
                EVENT_DATE: "108/04/17",
                EVENT_SER_NO: "19246",
                EVENT_TIME: "15:00",
                EVENT_YEAR: "2019",
                ISMISS: "Y",
                NOTE_STRING: "您尚未填寫私人筆記",
                RECORD_STRING: "您尚未填寫活動日誌",
                RECORD_SYMBOL: "001",
                REFERRAL1: "",
                REFERRAL2: "",
                SUB_CLS_CODE: "A0101產險,A0404滿期金/年金",
            },
            {
                EVENT_DATE: "108/03/18",
                EVENT_SER_NO: "19107",
                EVENT_TIME: "17:05",
                EVENT_YEAR: "2019",
                ISMISS: "N",
                NOTE_STRING: "您尚未填寫私人筆記",
                RECORD_STRING: "006",
                RECORD_SYMBOL: "006",
                REFERRAL1: "",
                REFERRAL2: "",
                SUB_CLS_CODE: "A0105房貸,A0202資料收集,A0301壽險,A0404滿期金/年金,A0502OPP",
            },
        ],
    },
    header: {
        message: "MXC3_1020 : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getAdditionalInsuranceProduct = {
    body: {
        ProductList: [
            {ProductName: "MIS收入保障健康保險附約(乙型)", ProductId: "670867302c3646f5b4e76cf84d62b0e8"},
            {ProductName: "MIS收入保障健康保險附約(丁型)", ProductId: "4d23ab5719ed4805a3743bcc9d802d5e"},
            {ProductName: "MIS收入保障健康保險附約(丙型)", ProductId: "9af1f13876d84dab8dd1fbe3b3a591e4"},
            {ProductName: "MIS收入保障健康保險附約(甲型)", ProductId: "e72be967da8b41b38555b05583237aa5"},
            {ProductName: "MTR多型態定期壽險附約(乙型)", ProductId: "0abda5b374314e3e813997bf32c2cf82"},
            {ProductName: "MTR多型態定期壽險附約(丙型)", ProductId: "1f8545618df045be8e652b9e31c1fe27"},
            {ProductName: "MTR多型態定期壽險附約(甲型)", ProductId: "9fc5e940f8f24672ac05f6cfe9c6192b"},
            {ProductName: "一年期手術健康保險附約", ProductId: "4fd3c925c09e4540bb743fb92b413dd5"},
            {ProductName: "一年期防癌健康保險附約", ProductId: "719c22c1553b469894c16ea8bd43608c"},
            {ProductName: "大好住院手術醫療終身健康保險附約", ProductId: "1f3d7746ad7e46d9a0330142f21bdc19"},
            {ProductName: "大好特定疾病終身健康保險附約", ProductId: "fcee9e38d5c540879f4b5bcc1c3cb0a7"},
            {ProductName: "手術醫療保險附約", ProductId: "4a98e31b5f6c4dd58a1629d9cb3f30a6"},
            {ProductName: "手術醫療保險附約(子女)", ProductId: "0ea4bccbf3b1429aaac478e61ae6c9ad"},
            {ProductName: "平安意外傷害321保險附約", ProductId: "c325844a74cb4a6e8cfd81a4dcd508c7"},
            {ProductName: "平安意外傷害321保險附約", ProductId: "dbed124e266c4c3c9ae1c8216fff5cb3"},
            {ProductName: "平安意外傷害321保險附約(定期)", ProductId: "d902419e2b264c21827d86fc485f096a"},
            {ProductName: "平安意外傷害保險附約(死殘)", ProductId: "03c1b0c53f2349f2b2a1cae3a17fa68e"},
            {ProductName: "平安意外傷害保險附約(死殘)", ProductId: "3ab0fa8173e54c6aa7c334c8892b187b"},
            {ProductName: "平安意外傷害保險附約(死殘)", ProductId: "974ec90d31ba467d9db148af8d9be43f"},
            {ProductName: "平安意外傷害保險附約(死殘)(子女)", ProductId: "c4ba3d0a22634f83bd4d984915185447"},
            {ProductName: "平安意外傷害保險附約(死殘)(定期)", ProductId: "7ef4ec7744ac49a198ef3a28e53ce5fc"},
            {ProductName: "生前給付保險金批註條款", ProductId: "6bc212080d9c4e938bed5f00ff5c467d"},
            {ProductName: "好安心定期健康保險附約", ProductId: "5674188bb773486089fb6ce4ca6035db"},
            {ProductName: "守護平安定期傷害醫療保險附約", ProductId: "57286fcc102c490d94b160f1be0b9651"},
            {ProductName: "守護滿分定期健康保險附約", ProductId: "d1bc2e83cd634f6191dd804ed79dde63"},
            {ProductName: "安心住院保險附約(新修訂)(擇優))", ProductId: "cf889dd9ddc340289ec2ecdc890edf50"},
            {ProductName: "安心住院保險附約(擇優)", ProductId: "93d3a3cbee864a4c8605f88b3e77bf46"},
            {ProductName: "安心意外傷害保險附約", ProductId: "e3ab733c7fc74537bd278f2e51b662f9"},
            {ProductName: "安安傷害保險附約乙型", ProductId: "060937c286834824abce473d048f3ab4"},
            {ProductName: "安安傷害保險附約丁型", ProductId: "8b5cb84733e84e1cbd3f0e3a8d9eed83"},
            {ProductName: "安安傷害保險附約丙型", ProductId: "f21d46cf41854f24b323eb8e276c6e73"},
            {ProductName: "安安傷害保險附約戊型", ProductId: "5237ac30d9f2486f945e68e2a9f74242"},
            {ProductName: "安安傷害保險附約甲型", ProductId: "e08688541b0d4f8dbec5fd3ebcca5f31"},
            {ProductName: "安康住院保險附約(擇優)", ProductId: "e1af556a576a4779b5645af943d4b4f3"},
            {ProductName: "安親保障批註條款", ProductId: "9efba809379249dd89bf479e6833d0b0"},
            {ProductName: "住院費用保險附約(擇優)", ProductId: "bcc6483afb8841df9a989bb6b3787c0e"},
            {ProductName: "住院醫療日額(甲型)保險附約", ProductId: "3ea6fa6b500e40a2b05ca58687bd677b"},
            {ProductName: "住院醫療日額(甲型)保險附約(子女)", ProductId: "87a9ea90ce8549e3a981bb8467fb4ac0"},
            {ProductName: "住院醫療保險附約", ProductId: "3ec167b5f1a547e5926653e384dce347"},
            {ProductName: "防癌批註條款(個人型)", ProductId: "cef1cd9683d344dabd3a37062e411bd1"},
            {ProductName: "防癌批註條款(家庭型)", ProductId: "9b473604f9b34fcf8e4ef881fa9e2edb"},
            {ProductName: "防癌醫療保險(家庭型)", ProductId: "22cb2dee583f400f9827db0357a2af26"},
            {ProductName: "防癌護照終身健康保險附約", ProductId: "1ab803bdd40b4ac1b462a4a6740ab6e0"},
            {ProductName: "防癌護照終身健康保險附約", ProductId: "b89afb1d82d04f879cb46227f07230f2"},
            {ProductName: "呵護安心住院醫療健康保險附約(擇優)", ProductId: "bdf428fc22864ba18eed79f7e7449fea"},
            {ProductName: "定期保險特約", ProductId: "64d3264e34514a7dae5884b0dbc1614a"},
            {ProductName: "定期保險特約", ProductId: "a233a44210194b5c95c6e5bf83c771fc"},
            {ProductName: "定期保險特約", ProductId: "b2c57c2db4be4e53b637c164e2e3743c"},
            {ProductName: "定期保險特約", ProductId: "baf5a42314ed4325bd7a847be56c9baf"},
            {ProductName: "定期保險特約", ProductId: "f97c503533bd441682b5f194001e86f3"},
            {ProductName: "幸福安康重大疾病終身健康保險附約(乙型)", ProductId: "7711ed40a0ee41c2a72064827718872c"},
            {ProductName: "治癌保險特約", ProductId: "8a0531de35bf46c0a88efe03e53cd7aa"},
            {ProductName: "長護久久終身健康保險附約", ProductId: "6640d78d393649dd9367f083407a1138"},
            {ProductName: "勇力骨傷害保險附約", ProductId: "c17f42e7142c445c94635be7199a2441"},
            {ProductName: "美元要保人豁免保險費附約", ProductId: "fdb3d03d587a4f7d9535587a89c5b276"},
            {ProductName: "要保人豁免保險費附約", ProductId: "139238dce4764b5e853e76cd363c2726"},
            {ProductName: "要保人豁免保險費附約", ProductId: "a3bf64e85cd3464fbc7dc59a998c875e"},
            {ProductName: "個人傷害門診給付特約", ProductId: "9127801239b74080a8be73433ae16076"},
            {ProductName: "家庭傷害門診給付特約", ProductId: "269fb99c1b2447799fe262724849eba5"},
            {ProductName: "家庭傷害保障特約(本人門診)", ProductId: "0591d8f27ace4271bf0320d3fd1d6c18"},
            {ProductName: "特定重大疾病附約", ProductId: "13c6a44ffaf54daa81112b7216ef6483"},
            {ProductName: "特定重大疾病附約", ProductId: "e26dc4fbe6da42069ecb20bdf3da8edb"},
            {ProductName: "特定處置終身健康保險附約", ProductId: "8c441e6bea2a48dfaf82bfb98f17ece9"},
            {ProductName: "配偶子女傷害特約", ProductId: "630aa1f69be445548f1ee5f4fb36b246"},
            {ProductName: "健康保險附約(手術津貼)", ProductId: "658b429214ce4457be1e23ffe9ba867c"},
            {ProductName: "健康保險特約", ProductId: "ca4fa7d17aa648ed865b287318046b76"},
            {ProductName: "健康保險特約(疾病住院醫療津貼)", ProductId: "cf693946a86c4ea4b0f294efa5596a7e"},
            {ProductName: "祥瑞定期壽險附約", ProductId: "04a6da78b4fc4799a58010c5dd0f083c"},
            {ProductName: "術術安心傷害保險附約", ProductId: "7c4f745dd0a34e23997943a1f83fd4b9"},
            {ProductName: "超安心一年期手術健康保險附約", ProductId: "99270d58bab2477ebbd2e04551e78f97"},
            {ProductName: "傷害住院日額保險附約(日額)", ProductId: "010863cf8d0341aa81f8f2562daabbc0"},
            {ProductName: "傷害住院日額保險附約(日額)", ProductId: "f51d23625d8244e8a8546388346ecf00"},
            {ProductName: "傷害住院日額保險附約(日額)(定期)", ProductId: "62de20b156cd47b4be16acec5c0250fb"},
            {ProductName: "傷害醫療保險金附加條款", ProductId: "81388d8257f046318cd42eb3d962ad9e"},
            {ProductName: "意外傷害失能保險附約", ProductId: "1a440eb3cc1c4057ac5f6fea0794fcd9"},
            {ProductName: "意外傷害失能保險附約", ProductId: "fa85c2b668d74fae86a3195040b70bd6"},
            {ProductName: "意外傷害給付特約", ProductId: "e20babcb085b4ee487a1573e489cc3b4"},
            {ProductName: "意外傷害醫療保險附約(限額)", ProductId: "442d7fd77e2f466d908db0b497606ce5"},
            {ProductName: "意外傷害醫療保險附約(限額)", ProductId: "c9157a5c068e4919996b96ee3293fb5f"},
            {ProductName: "意外傷害醫療保險附約(限額)(子女)", ProductId: "06329faac67e48fbb0fd46cc57c7161f"},
            {ProductName: "意外傷害醫療保險附約(限額)(定期)", ProductId: "983b1a8988424dc3a6925c79aae99d42"},
            {ProductName: "意外傷害醫療保險附約(新修訂)", ProductId: "cc35f537d6614476b37fbfb41ed6c50e"},
            {ProductName: "意外傷害醫療保險附約(新修訂)", ProductId: "e601e3231d2643efad73086e130014aa"},
            {ProductName: "新定期壽險附約", ProductId: "d685154968ca4bcc93a56e29589002db"},
            {ProductName: "新勇力骨傷害保險附約", ProductId: "c2215bf1cfc24bac9ac64d4daa920261"},
            {ProductName: "新要保人豁免保險費附約", ProductId: "3d00e490f23a4e1c822036da4d76d927"},
            {ProductName: "新要保人豁免保險費附約", ProductId: "3a04ec1f2aa045739b6d97f75c481d63"},
            {ProductName: "新要保人豁免保險費附約", ProductId: "dab89a9dd40b4d39b20e924be50cc8f1"},
            {ProductName: "新要保人豁免保險費附約(新定義)", ProductId: "79bd6c4dcc0b4466acf53c286a322281"},
            {ProductName: "新豁免保險費附約", ProductId: "b68d7d1088794c37bbef547d231069af"},
            {ProductName: "頌愛心小額終老傷害保險附約", ProductId: "af980ea7a6cc45ab806c204d91337125"},
            {ProductName: "綜合保障附約(個人型)", ProductId: "f02d5e25cf934815955920f9beb9eb6a"},
            {ProductName: "綜合保障附約(個人型)(定期)", ProductId: "f7bc9cb9193a4887b2c0d9913ecc33a3"},
            {ProductName: "綜合保障附約(家庭型)", ProductId: "0c2ceaec96a64bad934f7f997f58848a"},
            {ProductName: "綜合給付特約(個人型)", ProductId: "a96916b72f8a4c298bb1b89982a9f2f4"},
            {ProductName: "綜合給付特約(家庭型)", ProductId: "5211a015e6fd426aae30aea99dde2a62"},
            {ProductName: "綜合醫療保險附約", ProductId: "0abe89b0544b4d8781a2d03dad4b3a2b"},
            {ProductName: "增安心自負額住院醫療健康保險附約", ProductId: "ae3502543d494901b0a8ae1b3a6d2946"},
            {ProductName: "增額終身壽險附約", ProductId: "f830c721eca34de5815d525c8316da87"},
            {ProductName: "澳幣要保人豁免保險費附約", ProductId: "6562a5e2345c4010a7ead8f1a968a46e"},
            {ProductName: "豁免多多豁免保險費健康保險附約", ProductId: "cfacb2a7ee4442b7b3dfed373c78c024"},
            {ProductName: "豁免多多豁免保險費健康保險附約(新定義)", ProductId: "ad20839b4a2c49cab00733b2724d6328"},
            {ProductName: "豁免保險費附約", ProductId: "9b3429a3d9c3438193cd148f0c73b1c3"},
            {ProductName: "豁免保險費附約", ProductId: "d5cbc1d3a43b4011a8075bef51440d7f"},
            {ProductName: "豁免保險費附約", ProductId: "e20188acf60c4b47988b45e7ce87fb8f"},
            {ProductName: "豁免保險費附約", ProductId: "daa7aed374f8403dac48d768cbfd2ca9"},
            {ProductName: "豐利儲蓄壽險附約", ProductId: "e3f63c59d8a94d0ab591fe973f000ec5"},
            {ProductName: "鑫安豁免保險費附約", ProductId: "b3c18c2eff52440fae412e5e80917c7b"},
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"
    }
}

export const getAdditionalProductDetail = {
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"
    },
    body: {
        AmountCurrencytype: "",
        Code: "0000",
        CodeMSG: "查詢商品成功",
        InsuranceAmountUnit: "元",
        IsSchemes: false,
        SchemesList: Object,
        Unit: "元",
        YearPeriodsList: [{
            0: "01"
        }]        
    }
}

export const addCathayInsurance = {
    header: {
        message: "自行輸入國壽保單:新增成功",
        userDeviceIp: "10.87.23.52",
        status: "200"
    },
    body: {}
}

export const  getPrimaryContractDetail = {
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"
    },
    body: {
        AnnuityDate: "108/6/12",
        Applicant: "廖○億",
        BeneficiaryOfAnnuity: "謝○燕",
        BeneficiaryOfDeath: "廖○億",
        BeneficiaryOfGoodWish: "謝○熹",
        BeneficiaryOfMaturity: "廖○億",
        Code: "0000",
        CodeMSG: "成功",
        Company: "新光人壽  ",
        ContractType: "主約",
        InsuranceAmount: "10",
        InsuranceAmountUnit: "萬元",
        InsuranceDate: "108/6/12",
        InsuranceValue: "50",
        InsuredId: "C18768708E",
        InsuredName: "廖○億",
        MinGuaranteeDieAmount: "100",
        MinGuaranteeDueMoney: "100",
        PaymentWay: "月繳",
        PolicyExchangeRateText: "",
        PolicyNumber: "1111111222",
        Premium: "66",
        Product: "5KA (7 Plus利率變動型保險)",
        SchemeToBuy: "",
        SecondaryInsuredList: [
            { SecondaryInsuredID: "D28782340D", 
              SecondaryInsuredName: "蘇○瑜",
              SecondaryInsuredRelation: "子女"}
        ],
        Select_ProductId: "639c0335eba344ff847a1869fe1116cc",
        Unit: "萬元",
        UnitNo: "1",
        YearPeriodToBuy: "07" 
    } 
}

export const getAdditionalContractDetail = {
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"   
    },
    body: {
        code: "0000",
        codemsg: "成功",
        company: "新光人壽  ",
        contracttype: "附約",
        insuranceamount: "888",
        insuranceamountunit: "元",
        insurancedate: "107/2/10",
        insurancevalue: "88",
        insuredid: "C18768708E",
        insuredname: "廖○億",
        paymentway: "月繳",
        premium: "888",
        product: "H2 (一年期手術健康保險附約)",
        schemetobuy: "",
        secondaryinsuredlist: [
            { secondaryinsuredid: "N28876072F",
              secondaryinsuredname: "劉○妤",
              secondaryinsuredrelation: "配偶" }
        ],
        select_productid: "4fd3c925c09e4540bb743fb92b413dd5",
        unit: "元",
        yearperiodtobuy: "01" 
    }
}

export const queryAllocationList= {
    header: {
        message: "查詢成功",
        userId: "C18768708E", 
        userDeviceIp: "10.87.23.53", 
        status: "200"
    },
    body: {
        policy_list:[
            {
                ceagent: "0",
                ceapcnm: "謝○均",
                ceapcno: "A18468345H",
                ceclcar: "AH42100",
                ceclcid: "C18768708E",
                ceclcnm: "廖○億",
                ceclcno: "AH521",
                celpscs_nm: "繳清件",
                cenxpdt: "",
                ceplcno: "9092524750",
                d1_payaddr: "台北市大安區泰順街00巷00號0樓之0",
                d2_payaddr: "台北市大安區泰順街00巷00號0樓之0",
                idmark: "0",
                jcode: "QD",
                l_relation: "高",
                producer_segment: "CX",
                sum_ceplcno: 2,
                zip_code: "106  "
            },
            {
                ceagent: "0",
                ceapcnm: "謝○均",
                ceapcno: "A18468345H",
                ceclcar: "AH42100",
                ceclcid: "C18768708E",
                ceclcnm: "廖○億",
                ceclcno: "AH521",
                celpscs_nm: "繳清件",
                cenxpdt: "",
                ceplcno: "9091673565",
                d1_payaddr: "新北市新店區中央0街000巷0號0樓",
                d2_payaddr: "台北市大安區泰順街00巷00號0樓之0",
                idmark: "0",
                jcode: "QD",
                l_relation: "高",
                producer_segment: "CX",
                sum_ceplcno: 2,
                zip_code: "106  "
            },
            {
                ceagent: "0",
                ceapcnm: "張○美",
                ceapcno: "A28669065I",
                ceclcar: "AH42100",
                ceclcid: "C18768708E",
                ceclcnm: "廖○億",
                ceclcno: "AH521",
                celpscs_nm: "正常",
                cenxpdt: "",
                ceplcno: "9142689569",
                d1_payaddr: "新北市林口區仁愛路0段00巷00號0樓",
                d2_payaddr: "新北市林口區仁愛路0段00巷00號0樓",
                idmark: "V",
                jcode: "QD",
                l_relation: "高",
                producer_segment: "CX",
                sum_ceplcno: 1,
                zip_code: "244  "
            },
            {
                ceagent: "0",
                ceapcnm: "鄭○惠",
                ceapcno: "A28678522D",
                ceclcar: "AH42100",
                ceclcid: "C18768708E",
                ceclcnm: "廖○億",
                ceclcno: "AH521",
                celpscs_nm: "終身險滿期",
                cenxpdt: "",
                ceplcno: "5560793717",
                d1_payaddr: "台北市信義區松山路000巷0弄00號0樓",
                d2_payaddr: "台北市信義區松山路000巷0弄00號0樓",
                idmark: "0",
                jcode: "QD",
                l_relation: "中",
                producer_segment: "CX",
                sum_ceplcno: 1,
                zip_code: "11088"
            }
              
        ]
    },
}

export const getProductDetail = {
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"
    },
    body: {
        AmountCurrencytype: "",
        Code: "0000",
        CodeMSG: "成功",
        InsuranceAmountUnit: "萬",
        IsFloatInterest: false,
        IsSchemes: false,
        Unit: "元",
        YearPeriodsList: [{
            0: "07"
        }],
        schemesList: [{

        }]
    },
}

export const getAllInsurances = {
    header: {
        message: "新增成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
    body: {
        CasualtyInsuranceList: [
            {
                AgentID: "C18768708E",
                AmountOfInsurance: 0,
                CompanyName: "兆豐產物保險股份有限公司",
                ContractType: "意外險",
                DateInsurance: "108-01-01",
                FullName: "廖○億",
                InsuredID: "0713746637cd475ba55288bafc0cd800",
                PolicyNumber: "852741963",
                Premium: 1500,
                PropertyID: "1595a44ab62a4e4e83d19f19201ad440",
                PropertyLiabilityInsuranceCompanyId: "3e8783d602c540b9beed37e19e7b3123",
                Year: 25
            },
            {
                AgentID: "C18768708E",
                AmountOfInsurance: 100000,
                CompanyName: "兆豐產物保險股份有限公司",
                ContractType: "團體傷害險",
                DateInsurance: "108-02-10",
                FullName: "謝○熹",
                InsuredID: "760f11b39bd84af2b8062f0cedc12571",
                PolicyNumber: "456347372F2143",
                Premium: 5000,
                PropertyID: "cdb51780a703495e9f3c1890ce8cc6d6",
                PropertyLiabilityInsuranceCompanyId: "3e8783d602c540b9beed37e19e7b3123",
                Year: 1,
            },
            {
                AgentID: "C18768708E",
                AmountOfInsurance: 10000,
                CompanyName: "第一產物保險公司",
                ContractType: "意外險",
                DateInsurance: "108-02-10",
                FullName: "廖○億",
                InsuredID: "4ec60595ad4b469c94967be0b5281d2d",
                PolicyNumber: "54658569545Y57",
                Premium: 100,
                PropertyID: "bc89d5c563894a4baeb6b89fbd9e24ed",
                PropertyLiabilityInsuranceCompanyId: "ccc81d46c746414fa6723c83c68d3e00",
                Year: 2,
            },
        ],
        Code: "0000",
        CodeMSG: "查詢產險保單成功",
        FireInsuranceList: [
            {
                AgentID: "C18768708E",
                ApplicantId: "4ec60595ad4b469c94967be0b5281d2d",
                CompanyName: "日商三井海上火災產物保險公司台北分公司  ",
                CompletionYear: 2015,
                ContractType: "住宅火險",
                DateInsurance: "106-06-10",
                FullName: "廖○億",
                PolicyNumber: "489456143789",
                Premium: 500000,
                PropertyID: "7ec7908b972741b9b99ed52d1c4e92f0",
                PropertyLiabilityInsuranceCompanyId: "99bc6275be1e40d4ad2b58b4018c295e",
                Year: 5,
            },
            {
                AgentID: "C18768708E",
                ApplicantId: "4ec60595ad4b469c94967be0b5281d2d",
                CompanyName: "富邦產物保險公司",
                CompletionYear: 2018,
                ContractType: "商業火險",
                DateInsurance: "107-06-10",
                FullName: "廖○億",
                PolicyNumber: "489786456897",
                Premium: 10000,
                PropertyID: "97a98d98412b4f5d9aa1ee6c7ee4c7d4",
                PropertyLiabilityInsuranceCompanyId: "1b5e070d21bd42e481ff64867d55c93b",
                Year: 4,
            },
            {
                AgentID: "C18768708E",
                ApplicantId: "cde81e7583e5477598216f0341b7342f",
                CompanyName: "中央產物保險公司",
                CompletionYear: 2019,
                ContractType: "住家綜合保險",
                DateInsurance: "108-01-10",
                FullName: "蘇○瑜",
                PolicyNumber: "897946468798",
                Premium: 80000,
                PropertyID: "1609994add6a460fa68616609dc468e5",
                PropertyLiabilityInsuranceCompanyId: "58511c2d837a4e53afd51bb671617683",
                Year: 3,
            },
        ],
        MotorInsuranceList: [
            {
                AgentID: "C18768708E",
                CarType: "現代",
                CompanyName: "台灣產物保險公司",
                ContractType: "汽車險(附加傷害險)",
                DateInsurance: "107-06-10",
                EngineNumber: "98515678E55",
                FullName: "廖○億",
                InsuredID: "4ec60595ad4b469c94967be0b5281d2d",
                LicensePlate: "BC-1234",
                PolicyNumber: "8521356788G123",
                Premium: 3254,
                PropertyID: "c434604f83ef4083a629a995438f5946",
                PropertyLiabilityInsuranceCompanyId: "8d126f405ee446ba814a7d2b34bca56b",
                Year: 2,
                YearOfManufacture: 2017,
            },
            {
                AgentID: "C18768708E",
                CarType: "光陽",
                CompanyName: "國泰世紀保險公司",
                ContractType: "機車險(附加傷害險)",
                DateInsurance: "108-01-10",
                EngineNumber: "844568H12686",
                FullName: "廖○億",
                InsuredID: "4ec60595ad4b469c94967be0b5281d2d",
                LicensePlate: "123-HKIG",
                PolicyNumber: "8545G61387978",
                Premium: 1250,
                PropertyID: "a6d90fcacaa64c59bb5fd6d861a36f51",
                PropertyLiabilityInsuranceCompanyId: "b424ba18fc824ea0857ca55a044d2cc8",
                Year: 2,
                YearOfManufacture: 2019,
            },
            {
                AgentID: "C18768708E",
                CarType: "YAMAHA",
                CompanyName: "統一安聯產物保險公司",
                ContractType: "機車險(任意險)",
                DateInsurance: "107-06-10",
                EngineNumber: "854613897E852",
                FullName: "蘇○瑜",
                InsuredID: "cde81e7583e5477598216f0341b7342f",
                LicensePlate: "DEF-123",
                PolicyNumber: "95362L456789466",
                Premium: 980,
                PropertyID: "4eedb0460ebb44768786c338c0926ad7",
                PropertyLiabilityInsuranceCompanyId: "5aa180460e904055a1354b6daa73e65c",
                Year: 2,
                YearOfManufacture: 2015,
            },
        ],
    },
}

export const getAllCompany = {
    body: {
        Code: "0000",
        CodeMSG: "成功",
        CompanyList: [
            {
                CompanyId: "58511c2d837a4e53afd51bb671617683",
                CompanyShortName: "中央產物保險公司",
            },
            {
                CompanyId: "1b3d2f73028d4a20989330197acce8f4",
                CompanyShortName: "中國產物保險公司",
            },
            {
                CompanyId: "da0db3f830ab4b9fadbb22bfca42b073",
                CompanyShortName: "友邦產物保險公司",
            },
            {
                CompanyId: "41fed9098e8c4de2afee4fdf7919ad2d",
                CompanyShortName: "太平產物保險公司",
            },
            {
                CompanyId: "99bc6275be1e40d4ad2b58b4018c295e",
                CompanyShortName: "日商三井海上火災產物保險公司台北分公司 ",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getInsuranceCompanyList = {
    body: {
        Code: "0000",
        CodeMSG: "成功",
        CompanyList: [
            {
                CompanyId: "2564c669825f4409b9b1908819514c0a",
                CompanyShortName: "國泰人壽",
            },
            {
                CompanyId: "f5040bcf5f2f42e2bce5793ac5b36238",
                CompanyShortName: "新光人壽",
            },
            {
                CompanyId: "2007643ddf584961aa9ad51d0f65d0b2",
                CompanyShortName: "南山人壽",
            },
            {
                CompanyId: "9594c39ec58b463d8dc0e29d39f68c8e",
                CompanyShortName: "國華人壽",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getInsuraneProduct = {
    body: {
        Code: "0000",
        CodeMSG: "成功",
        ProductList: [
            {
                ProductId: "4e6ef131c72d4ba6ba1ff0e9a91ed9bc",
                ProductName: "(喬治亞)一年定期壽險",
            },
            {
                ProductId: "fb69a8d8baca4034b0522fa6644f6068",
                ProductName: "(喬治亞)人身意外傷害保險",
            },
            {
                ProductId: "a0ebc4d1304f4c58b94666b039998586",
                ProductName: "(喬治亞)子女成長年金保險(乙型)",
            },
            {
                ProductId: "ebba81e07768406c935b461f08eca83f",
                ProductName: "(喬治亞)子女成長年金保險(丁型)",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getGoogleMapLocation = {
    body: {
        inag_info: {agidno: "S18990655I", ceempnm: "呂○憲", cepsndg: "VB", clcno: "EB1289A", producer_segment: "G"},
        policy_list: [
            {
                ceagent: "0",
                ceapcnm: "胡○秀",
                ceapcno: "A28790374D",
                ceclcar: "EB13038",
                ceclcid: "S28624857J",
                ceclcnm: "簡○美",
                ceclcno: "EB13038",
                celpscs_nm: "正常",
                cenxpdt: "2019-05-11",
                ceplcno: "9002134877",
                d1_payaddr: "高雄市0民區寶獅里0鄰大順0路000巷000號",
                d2_payaddr: "高雄市0民區寶獅里0鄰大順0路000巷000號",
                idmark: "0",
                jcode: "K4",
                l_relation: "中高",
                latitude: 22.635715,
                longitude: 120.336122,
                producer_segment: "D",
                sum_ceplcno: 1,
                zip_code: "80764",
            },
            {
                ceagent: "0",
                ceapcnm: "童○英",
                ceapcno: "A28864351D",
                ceclcar: "EB13038",
                ceclcid: "S28624857J",
                ceclcnm: "簡○美",
                ceclcno: "EB13038",
                celpscs_nm: "正常",
                cenxpdt: "2020-02-13",
                ceplcno: "7244885432",
                d1_payaddr: "高雄市左營區重立路000號00樓",
                d2_payaddr: "高雄市左營區重立路000號00樓",
                idmark: "0",
                jcode: "K4",
                l_relation: "中",
                latitude: 22.674752,
                longitude: 120.313773,
                producer_segment: "D",
                sum_ceplcno: 1,
                zip_code: "81364",
            },
            {
                ceagent: "1",
                ceapcnm: "賴○甄",
                ceapcno: "B28821927I",
                ceclcar: "EB13038",
                ceclcid: "S28624857J",
                ceclcnm: "簡○美",
                ceclcno: "EB13038",
                celpscs_nm: "正常",
                cenxpdt: "2019-09-02",
                ceplcno: "9118012035",
                d1_payaddr: "高雄市鼓山區美術北0路000號00樓",
                d2_payaddr: "高雄市鼓山區美術北0路000號00樓",
                idmark: "0",
                jcode: "K4",
                l_relation: "中高",
                latitude: 22.66345,
                longitude: 120.287666,
                producer_segment: "D",
                sum_ceplcno: 2,
                zip_code: "80457",
            },
        ],
        rows: 3,
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "S18990655I",
    },
}

export const getCustVisitItem = {
    body: {
        detail: {
            agidno: "",
            cls_nm_1: "一1",
            cls_nm_2: "二2",
            cls_nm_3: "三3",
            cls_nm_4: "四4",
            cls_nm_5: "五5",
            source: "",
        },
        hostname: "cxlboxat01",
        returncode: "0",
        returnmsg: "API success",
        uuid: "AY_API1093_20190621_C60450ED7C_T01",
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCustDefaultItem = {
    body: {
        cls_item: [
            {cls_nm: "產險", cls_code: "A0101"},
            {cls_nm: "車險預約單", cls_code: "A0102"},
            {cls_nm: "開戶", cls_code: "A0103"},
            {cls_nm: "信用卡", cls_code: "A0104"},
            {cls_nm: "房貸", cls_code: "A0105"},
            {cls_nm: "房貸訪問表", cls_code: "A0106"},
            {cls_nm: "易Call保", cls_code: "A0107"},
            {cls_nm: "贈送媒體", cls_code: "A0108"},
            {cls_nm: "觀念溝通", cls_code: "A0109"},
            {cls_nm: "轉介紹", cls_code: "A0112"},
            {cls_nm: "二代健保", cls_code: "A0113"},
            {cls_nm: "送禮", cls_code: "A0114"},
            {cls_nm: "保單健檢", cls_code: "A0201"},
            {cls_nm: "資料收集", cls_code: "A0202"},
            {cls_nm: "四象限", cls_code: "A0203"},
            {cls_nm: "帆船理論", cls_code: "A0204"},
            {cls_nm: "家庭保障", cls_code: "A0205"},
            {cls_nm: "醫療保障", cls_code: "A0206"},
            {cls_nm: "子女教育", cls_code: "A0207"},
            {cls_nm: "退休養老", cls_code: "A0208"},
            {cls_nm: "投資理財", cls_code: "A0209"},
            {cls_nm: "稅務規劃", cls_code: "A0210"},
            {cls_nm: "壽險", cls_code: "A0301"},
            {cls_nm: "醫療險", cls_code: "A0302"},
            {cls_nm: "儲蓄險", cls_code: "A0303"},
            {cls_nm: "意外險", cls_code: "A0304"},
            {cls_nm: "年金險", cls_code: "A0305"},
            {cls_nm: "投資險", cls_code: "A0306"},
            {cls_nm: "旅平險", cls_code: "A0307"},
            {cls_nm: "人工/自繳", cls_code: "A0401"},
            {cls_nm: "保費", cls_code: "A0402"},
            {cls_nm: "理賠", cls_code: "A0403"},
            {cls_nm: "滿期金/年金", cls_code: "A0404"},
            {cls_nm: "指定拜訪", cls_code: "A0405"},
            {cls_nm: "墊滾/催停", cls_code: "A0406"},
            {cls_nm: "電子單據", cls_code: "A0407"},
            {cls_nm: "保全", cls_code: "A0408"},
            {cls_nm: "保單活化", cls_code: "A0410"},
            {cls_nm: "行動服務", cls_code: "A0411"},
            {cls_nm: "保單簽收回條", cls_code: "A0412"},
            {cls_nm: "增員關係建立", cls_code: "A0501"},
            {cls_nm: "OPP", cls_code: "A0502"},
            {cls_nm: "初次面談", cls_code: "A0503"},
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getOutTransferMember  = {
    body: {
        ag:[{
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH521",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 20,
                tmp6: 0
            },
            {
                agidno: "N26630132A",
                ceempnm: "洪○美",
                cepsnnm: "業務主任（二）",
                clcno: "AH52118",
                syear: 2,
                t1workagent: "92870.10",
                tmp0: 1135,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52119",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52158",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52160",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52161",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "A28693181E",
                ceempnm: "黃○美",
                cepsnnm: "業務主任（二）",
                clcno: "AH52163",
                syear: 11.5,
                t1workagent: "97880.90",
                tmp0: 718,
                tmp6: 0
            },
            {
                agidno: "A26974319G",
                ceempnm: "曾許○珠",
                cepsnnm: "業務襄理（二）",
                clcno: "AH52183",
                syear: 18.8,
                t1workagent: "130370.60",
                tmp0: 1092,
                tmp6: 0
            },
        ] 
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"     
    },
}

export const getInTransferMember  = {
    body: {
        ag:[{
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH521",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 20,
                tmp6: 0
            },
            {
                agidno: "N26630132A",
                ceempnm: "洪○美",
                cepsnnm: "業務主任（二）",
                clcno: "AH52118",
                syear: 2,
                t1workagent: "92870.10",
                tmp0: 1135,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52119",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52158",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52160",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "C18768708E",
                ceempnm: "廖○億",
                cepsnnm: "展業區襄理（一）",
                clcno: "AH52161",
                syear: 15.8,
                t1workagent: "266888.60",
                tmp0: 0,
                tmp6: 0
            },
            {
                agidno: "A28693181E",
                ceempnm: "黃○美",
                cepsnnm: "業務主任（二）",
                clcno: "AH52163",
                syear: 11.5,
                t1workagent: "97880.90",
                tmp0: 718,
                tmp6: 0
            },
            {
                agidno: "A26974319G",
                ceempnm: "曾許○珠",
                cepsnnm: "業務襄理（二）",
                clcno: "AH52183",
                syear: 18.8,
                t1workagent: "130370.60",
                tmp0: 1092,
                tmp6: 0
            },
        ] 
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "C18768708E"
    },
}
export const queryNreChargeList = {
    body: {
        query_nrechargepl:[
            {
                ceapcnm: "辜○益",
                ceapcno: "A16904378I",
                ceclcid_new: "H28781660I",
                ceclcnm: "汪○蘭",
                ceclcno: "A819811",
                ceclcno_new: "A819809",
                celpscs_nm: "終身險滿期",
                ceplcdt: "2000-12-14",
                ceplcno: "0000151991",
                e5: "2019-06-17",
                e5id: "G18798512D",
                e5nm: "陳○義",
                l_relation: "高",
                service_time: 18.3                
            },
        ],
        query_nrechargeunit:[
            {
                ceadcd: "A400000",
                ceadnm: "專招台北第一區部",
                ceclcar: "A8198",
                cedvnm: "專招城北通訊處（一）瑞鈺推展處",
                cedvno: "A819800"  
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "H28950545H"     
    },
}


export const selectMessage = {
    body: {
        
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "H28950545H"  
    },
}

export const getCustDie = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.58",
        userId: "H28950545H"  
    },
}

export const queryMainPolicyInfo = {
    body: {
        ACT_DIV_NO: "",
        ADDR: "台北市松山",
        AGE: "38",
        APC_BRDY: "1978-03-16",
        APC_ID: "C18768708E",
        APC_NM: "廖○億",
        AUTO_PREM_CODE_CH: "要自動墊繳",
        DVD_KIND_CH: "無紅利",
        EFT_CODE_NM: "正常",
        INSD_BRDY: "1978-03-16",
        INSD_ID: "C18768708E",
        INSD_NM: "廖○億",
        ISSUE_DATE: "2016-01-26",
        IS_GROUP: "N",
        LST_CHG_DATE: "2019-01-29 23:50:36.935",
        LST_CHG_KIND_CH: "保費更新入帳",
        MED_EXAM_CH: "無體檢",
        MOBILE_TEL: "0910123456",
        POLICY_NO: "9123503896",
        URL: "https://w3.cathaylife.com.tw/PIWeb/web/tf/traditional/nmc/現售商品專區.html",
        ZIP_CODE: "105  ",
    },
    header: {
        message: "SERVICE_API: Success",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryMainPolicyBeneficiariesInfo = {
    body: {
        rider_list: [
            {
                bene_name: "廖○億",
                bene_prio: "",
                bene_rato: "100.00",
                bene_type_ch: "滿期",
                policy_no: "9123503896",
                prod_id: "N61",
                prod_id_ch: "國泰人壽新安家保本定期保險",
                rltn_ch: "本人",
            },
            {
                bene_name: "蘇○瑜",
                bene_prio: "",
                bene_rato: "100.00",
                bene_type_ch: "身故",
                policy_no: "9123503896",
                prod_id: "N61",
                prod_id_ch: "國泰人壽新安家保本定期保險",
                rltn_ch: "配偶",
            },
        ],
    },
    header: {
        message: "查詢附約受益人明細失敗 查無附約受益人資料，保單號碼：9123503896",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryInvestProfit = {
    body: {
        investmentSetting: {
            record1Data5: {
                dataList: [
                    {
                        AFT_BOU_TYPE_OPT_C: "",
                        KIND_C: "收益分配或撥回資產分配方式",
                    }
                ],
                keyDate: "2005-12-28"
            }
        },
        profitSettings: {

        }
    },
    header: {
        message: " MXC4_1605 : 查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editCustFinancial = {
    body: {
        
    },
    header: {
        message: "更新財務狀況成功;同步至舊系統成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editCustInfo = {
    body: {
        
    },
    header: {
        message: "修改客戶成功;同步至舊系統成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const modifyCustomizeFilter = {
    body: {
        
    },
    header: {
        message: "MODIFYOWNCONDITION_API : 修改成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const modifyFavorite = {
    body: {},
    header: {
        message: "修改成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const deleteFavorite = {
    body: {
        
    },
    header: {
        message: "刪除成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addOtherPrimaryContract = {
    body: {
        code: "0001",
        codemsg: "新增成功",
    },
    header: {
        message: "新增成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addOtherAdditionalContract = {
    body: {
        code: "0001",
        codemsg: "新增成功",
    },
    header: {
        message: "新增成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const deleteOtherContract = {
    body: {
        code: "0003",
        codemsg: "刪除成功",
    },
    header: {
        message: "刪除成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const modifyOtherAdditionalContract = {
    body: {
        code: "0002",
        codemsg: "修改成功",
    },
    header: {
        message: "編輯成功",
        status: "200",
    },
}

export const modifyOtherPrimaryContract = {
    body: {
        
    },
    header: {
        message: "編輯同業壽險主約:修改成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addMotorInsurances = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editMotorInsurances = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addFireInsurances = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editFireInsurances = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addNewTypeInsurances = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editNewTypeInsurances = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const addOtherInsuranceNote = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editOtherInsuranceNote = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const deleteOtherInsurances = {
    body: {
        
    },
    header: {
        message: "刪除成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const editVisitRecord = {
    body: {
        
    },
    header: {
        message: "成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryEstrangeAgList = {
    body: {
        ag: [
            {
                ceclcid: "A28693181E",
                ceclcnm: "黃○美",
                ceclcno: "AH52163",
            },
            {
                ceclcid: "A26974319G",
                ceclcnm: "曾許○珠",
                ceclcno: "AH52183",
            },
            {
                ceclcid: "A28631004I",
                ceclcnm: "楊○苑",
                ceclcno: "AH525",
            },
            {
                ceclcid: "C28609086F",
                ceclcnm: "吳○佩",
                ceclcno: "AH52C96",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryEstrangePlList = {
    body: {
        ag: [
            {
                ceclcid: "A28693181E",
                ceclcnm: "黃○美",
                ceclcno: "AH52163",
            },
            {
                ceclcid: "A26974319G",
                ceclcnm: "曾許○珠",
                ceclcno: "AH52183",
            },
            {
                ceclcid: "R28677630I",
                ceclcnm: "郭○容",
                ceclcno: "AH52E08",
            },
            {
                ceclcid: "F28982351A",
                ceclcnm: "簡○慧",
                ceclcno: "AH52F86",
            },
            {
                ceclcid: "H28722245F",
                ceclcnm: "葉○玉",
                ceclcno: "AH54751",
            },
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryRechargeRecord = {
    body: {
        records: [
            {
                agname_new: "張○祥",
                agname_old: "廖○億",
                ceclcid_new: "G18676124F",
                ceclcid_old: "C18768708E",
                ceclcno_new: "AH5",
                ceclcno_old: "AH521",
                code_nm: "空區空股",
                date: "2019-06-27",
                producer_segment: "CX",
            },
            {
                agname_new: "廖○億",
                agname_old: "張○祥",
                ceclcid_new: "C18768708E",
                ceclcid_old: "G18676124F",
                ceclcno_new: "AH521",
                ceclcno_old: "AH5",
                code_nm: "空區空股",
                date: "2019-06-26",
                producer_segment: "CX",
            },
            {
                agname_new: "廖○億",
                agname_old: "張○祥",
                ceclcid_new: "C18768708E",
                ceclcid_old: "G18676124F",
                ceclcno_new: "AH521",
                ceclcno_old: "AH5",
                code_nm: "空區空股",
                date: "2019-06-27",
                producer_segment: "CX",
            },
            {
                agname_new: "曾許○珠",
                agname_old: "洪○美",
                ceclcid_new: "A26974319G",
                ceclcid_old: "N26630132A",
                ceclcno_new: "AH52183",
                ceclcno_old: "AH52118",
                code_nm: "單位服務人員",
                date: "2019-06-28",
                producer_segment: "D",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryRechargeRecordDetail = {
    body: {
        record_detail: [
            {
                agname_new: "張○祥",
                agname_old: "廖○億",
                ceapcnm: "謝○均",
                ceapcno: "A18468345H",
                ceclcid_new: "G18676124F",
                ceclcid_old: "C18768708E",
                ceclcno_new: "AH5",
                ceclcno_old: "AH521",
                ceplcno: "9091673565",
            },
            {
                agname_new: "張○祥",
                agname_old: "廖○億",
                ceapcnm: "謝○均",
                ceapcno: "A18468345H",
                ceclcid_new: "G18676124F",
                ceclcid_old: "C18768708E",
                ceclcno_new: "AH5",
                ceclcno_old: "AH521",
                ceplcno: "9092524750",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getSearchRecordFirstEight  = {
    "header": {
        "message": "查詢成功",
        "userId": "C18768708E",
        "userDeviceIp": "10.87.23.51",
        "status": "200"
    },
    "body": [
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:05:28.097725",
            "searchkeyword": "敏鎬"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:05:09.925167",
            "searchkeyword": "王"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:04:31.306969",
            "searchkeyword": "楊"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:04:21.849923",
            "searchkeyword": "國"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:04:03.749669",
            "searchkeyword": "910"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:03:55.771627",
            "searchkeyword": "黃○"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:03:20.127106",
            "searchkeyword": "N13456789A"
        },
        {
            "agidno": "C18768708E",
            "searchtime": "2019-06-24 16:02:51.788543",
            "searchkeyword": "陳"
        }
    ]
}

export const getChangeNotice = {
    body: {
        notice_list: [
            {
                ceapcnm: "黃○松",
                ceapcno: "R18651852I",
                celpscs_nm: "正常",
                cenxpdt: "2016-06-22",
                ceplcno: "7040139413",
                clcid: "T28740559H",
                fin: "0",
                idmark: "0",
                last_visitday: "2015-12-31",
                visit_no: "G011668305",
            },
            {
                ceapcnm: "鍾○惠",
                ceapcno: "E28794259D",
                celpscs_nm: "正常",
                cenxpdt: "2015-09-02",
                ceplcno: "7907997329",
                clcid: "T28740559H",
                fin: "0",
                idmark: "0",
                last_visitday: "2015-12-31",
                visit_no: "G011738231",
            },
            {
                ceapcnm: "傅○怡",
                ceapcno: "S28742502F",
                celpscs_nm: "繳清件",
                ceplcno: "7800349820",
                clcid: "T28740559H",
                fin: "0",
                idmark: "0",
                last_visitday: "2016-02-29",
                visit_no: "G017500964",
            },
            {
                ceapcnm: "黃○發",
                ceapcno: "Q18708752B",
                celpscs_nm: "終身險滿期",
                ceplcno: "7909181865",
                clcid: "T28740559H",
                fin: "0",
                idmark: "0",
                last_visitday: "2016-02-29",
                visit_no: "G017505254",
            },
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "T28740559H",
    },
}

export const getListArea = {
    body: {
        cate_list: [
            {
                cate_serno: "003",
                category: "精準行銷",
                category_name: "一件鍾情",
                cust_count: 30,
                cust_list: ['張○琴','王test'],
                description: "0~41歲。未購買重疾險，購買機會相對高(模型預測)，核保機會相對高。",
                end_date: "2020-09-04",
                isquarterly: "Y",
                subcategory: "High客名單",
                upload_date: "2019-06-13",
            },
            {
                cate_serno: "014",
                category: "服務/權益",
                category_name: "即將停效 ",
                cust_count: 36,
                cust_list: ['張○琴','王test'],
                description: "客戶保單即將停效，趕緊聯絡客戶，避免客戶權益受損。",
                isquarterly: "Y",
                subcategory: "權益類",
                upload_date: "2019-01-01",
            },
            {
                cate_serno: "009",
                category: "服務/權益",
                category_name: "迎賓禮(符合資格)",
                cust_count: 70,
                cust_list: ['張○琴','王test'],
                description: "為提升VIP服務有感度，將提供VIP迎賓禮盒予特定VIP保戶",
                isquarterly: "N",
                subcategory: "VIP專區",
                upload_date: "2018-04-01",
            },
        ],
        top10_list: [
            {
                category: "服務/權益",
                category_name: "即將停效 ",
                ser_no: "014",
                subcategory: "權益類",
            },
            {
                category: "服務/權益",
                category_name: "迎賓禮(符合資格)",
                ser_no: "009",
                subcategory: "VIP專區",
            },
            {
                category: "精準行銷",
                category_name: "一件鍾情",
                ser_no: "003",
                subcategory: "High客名單",
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryInfoA = {
    body: [
        {
            category: "精準行銷",
            category_name: "受益量多",
            cust_count: "0",
            end_date: "2020-09-04",
            ser_no: "001",
            subcategory: "High客名單",
            upload_date: "2019-06-13",
            cust_list: [],
        },
        {
            category: "精準行銷",
            category_name: "公教長照",
            cust_count: "0",
            ser_no: "005",
            subcategory: "特定專案推動",
            upload_date: "2019-07-01",
            cust_list: [],
        },
        {
            category: "精準行銷",
            category_name: "實支實付目標客戶",
            cust_count: "0",
            ser_no: "006",
            subcategory: "特定專案推動",
            upload_date: "2019-07-01",
            cust_list: [],
        },
        {
            category: "精準行銷",
            category_name: "缺醫不可 ",
            cust_count: "0",
            end_date: "2020-09-04",
            ser_no: "002",
            subcategory: "High客名單",
            upload_date: "2019-06-13",
            cust_list: [],
        },
        {
            category: "精準行銷",
            category_name: "一件鍾情",
            cust_count: "30",
            end_date: "2020-09-04",
            ser_no: "003",
            subcategory: "High客名單",
            upload_date: "2019-06-13",
            cust_list: [],
        },
        {
            category: "精準行銷",
            category_name: "身心障礙",
            cust_count: "0",
            ser_no: "004",
            subcategory: "特定專案推動",
            upload_date: "2019-01-01",
            cust_list: [],
        },
        {
            category: "精準行銷",
            category_name: "小額終老",
            cust_count: "0",
            ser_no: "024",
            subcategory: "特定專案推動",
            upload_date: "2019-07-01",
            cust_list: [],
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryInfoB = {
    body: [
        {
            category: "集團相關",
            category_name: "國泰伴你健康",
            ser_no: "022",
            subcategory: "健康管理",
            upload_date: "2018-12-10",
            cust_list: [],
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryInfoC = {
    body: [
        {
            category: "服務/權益",
            category_name: "線上諮詢",
            cust_count: "0",
            ser_no: "013",
            subcategory: "服務類",
            upload_date: "2019-05-08",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "即將停效 ",
            cust_count: "36",
            ser_no: "014",
            subcategory: "權益類",
            upload_date: "2019-01-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "停效後半年",
            cust_count: "0",
            ser_no: "015",
            subcategory: "權益類",
            upload_date: "2019-01-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "尊榮服務(符合資格)",
            cust_count: "0",
            ser_no: "007",
            subcategory: "VIP專區",
            upload_date: "2012-01-18",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "推動名單(升/降等)",
            cust_count: "0",
            ser_no: "008",
            subcategory: "VIP專區",
            upload_date: "2012-01-18",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "迎賓禮(符合資格)",
            cust_count: "0",
            ser_no: "009",
            subcategory: "VIP專區",
            upload_date: "2018-04-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "健康禮(符合資格)",
            cust_count: "0",
            ser_no: "010",
            subcategory: "VIP專區",
            upload_date: "2018-11-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "國泰一家人(家庭服務)",
            cust_count: "0",
            ser_no: "011",
            subcategory: "VIP專區",
            upload_date: "2018-10-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "免費健檢(符合資格)",
            cust_count: "0",
            ser_no: "012",
            subcategory: "VIP專區",
            upload_date: "2011-03-10",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "滿期年金未辦",
            cust_count: "0",
            ser_no: "016",
            subcategory: "權益類",
            upload_date: "2017-05-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "未兌現支票",
            cust_count: "0",
            ser_no: "017",
            subcategory: "權益類",
            upload_date: "2017-05-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "保單給付應領未領",
            cust_count: "0",
            ser_no: "025",
            subcategory: "權益類",
            upload_date: "2017-05-01",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "異動後實質接觸明細",
            cust_count: "0",
            ser_no: "023",
            subcategory: "服務類",
            cust_list: [],
        },
        {
            category: "服務/權益",
            category_name: "疏遠件預警",
            cust_count: "0",
            ser_no: "026",
            subcategory: "服務類",
            upload_date: "2019-07-01",
            cust_list: [],
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryInfoD = {
    body: [
        {
            category: "整合行銷",
            category_name: "證券數位服務 ",
            ser_no: "020",
            subcategory: "證券/投信",
            upload_date: "2018-09-07",
            cust_list: [],
        },
        {
            category: "整合行銷",
            category_name: "高資產複委託",
            ser_no: "021",
            subcategory: "證券/投信",
            upload_date: "2019-02-11",
            cust_list: [],
        },
        {
            category: "整合行銷",
            category_name: "外幣匯款手續費優惠",
            ser_no: "019",
            subcategory: "銀行",
            upload_date: "2016-02-01",
            cust_list: [],
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getChangeReprot = {
    body: {
        notice_contact: {
            ceapcno: "A26676250A",
            clcid: "C18768708E",
        }
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const queryBelowEstrangePolicyContactInfo = {
    body: {
        detail: {
            addr_c_city_nm: "",
            addr_c_line_1: "",
            addr_c_line_2: "",
            addr_c_postal_cd: "",
            addr_c_source_cd: "",
            addr_c_update: "",
            addr_h_city_nm: "",
            addr_h_line_1: "",
            addr_h_line_2: "",
            addr_h_postal_cd: "",
            addr_h_update: "",
            addr_newest_city_nm: "",
            addr_newest_line_1: "",
            addr_newest_line_2: "",
            addr_newest_postal_cd: "",
            addr_newest_source_cd: "",
            addr_newest_update: "",
            addr_p_city_nm: "",
            addr_p_line_1: "",
            addr_p_line_2: "",
            addr_p_postal_cd: "",
            addr_p_update: "",
            email: "",
            email_source_cd: "",
            email_update: "",
            mobile01: "",
            mobile01_source_cd: "",
            mobile01_update: "",
            mobile02: "",
            mobile02_source_cd: "",
            mobile02_update: "",
            party_id: "",
            tel_h: "",
            tel_h_area: "",
            tel_h_ext: "",
            tel_h_source_cd: "",
            tel_h_update: "",
            tel_newest: "",
            tel_newest_area: "",
            tel_newest_ext: "",
            tel_newest_source_cd: "",
            tel_newest_update: "",
            tel_o: "",
            tel_o_area: "",
            tel_o_ext: "",
            tel_o_source_cd: "",
            tel_o_update: "",
            tel_p: "",
            tel_p_area: "",
            tel_p_ext: "",
            tel_p_source_cd: "",
            tel_p_update: "",
        }
    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C18768708E",
    },
}

export const getMoreBenefits = {
    body: {
        detail: [
            {
                ann_time: 0,
                cnt: "11",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "51/01/07",
                csidno: "A28879766J",
                csmtel: "",
                csname: "王○芳",
                customer_view: "決戰高峰",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "Y",
                group_c: "",
                group_d: "",
                idmark: {
                    source1: "1",
                    source2: "1",
                    source3: "0",
                    source4: "0",
                    source5: "0",
                    source6: "0",
                },
                latitude: "25.089754",
                licon: "E",
                longitude: "121.481962",
                marketing_mark: 0,
                previous_date: "",
                previous_ser_no: "",
                previous_time: "",
                previous_year: "",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "50/01/09",
                csidno: "A28900950G",
                csmtel: "",
                csname: "謝○玲",
                customer_view: "銀光閃閃",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "Y",
                group_c: "",
                group_d: "",
                idmark: {
                    source1: "1",
                    source2: "1",
                    source3: "0",
                    source4: "0",
                    source5: "0",
                    source6: "0",
                },
                latitude: "0.000000",
                licon: "B",
                longitude: "0.000000",
                marketing_mark: 0,
                previous_date: "",
                previous_ser_no: "",
                previous_time: "",
                previous_year: "",
                record_agcsrt: "",
                undo_marketing: 7,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "66/02/04",
                csidno: "G18774377I",
                csmtel: "",
                csname: "盧○村",
                customer_view: "受益量多",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "Y",
                group_c: "",
                group_d: "",
                idmark: {
                    source1: "1",
                    source2: "1",
                    source3: "0",
                    source4: "0",
                    source5: "0",
                    source6: "0",
                },
                latitude: "0.000000",
                licon: "E",
                longitude: "0.000000",
                marketing_mark: 1,
                previous_date: "107/08/14",
                previous_ser_no: "96811151",
                previous_time: "20:35",
                previous_year: "2018",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "49/09/10",
                csidno: "F18626718J",
                csmtel: "",
                csname: "吳○煌",
                customer_view: "受益量多",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "Y",
                group_c: "",
                group_d: "",
                idmark: {},
                latitude: "0.000000",
                licon: "E",
                longitude: "0.000000",
                marketing_mark: 0,
                previous_date: "108/06/21",
                previous_ser_no: "117198094",
                previous_time: "12:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "48/09/10",
                csidno: "A18741411E",
                csmtel: "",
                csname: "林○泰",
                customer_view: "數位悠遊",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "Y",
                group_c: "",
                group_d: "",
                idmark: {
                    source1: "1",
                    source2: "1",
                    source3: "0",
                    source4: "0",
                    source5: "0",
                    source6: "1",
                },
                latitude: "0.000000",
                licon: "D",
                longitude: "0.000000",
                marketing_mark: 0,
                previous_date: "108/07/10",
                previous_ser_no: "118481230",
                previous_time: "09:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 6,
                vip: "",
                visit_time: 0,
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getMedicalCare = {
    body: {
        detail: [
            {
                ann_time: 2,
                cnt: "7",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "75/01/02",
                csidno: "F28299832H",
                csmtel: "",
                csname: "廖○齊",
                customer_view: "缺醫不可",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "Y",
                group_d: "",
                idmark: {},
                latitude: "0.000000",
                licon: "E",
                longitude: "0.000000",
                marketing_mark: 0,
                previous_date: "",
                previous_ser_no: "",
                previous_time: "",
                previous_year: "",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "70/02/09",
                csidno: "F25672778B",
                csmtel: "",
                csname: "李○銀",
                customer_view: "缺醫不可",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "Y",
                group_d: "",
                idmark: {
                    source1: "1",
                    source2: "1",
                    source3: "0",
                    source4: "0",
                    source5: "0",
                    source6: "0",
                },
                latitude: "25.017613",
                licon: "E",
                longitude: "121.427087",
                marketing_mark: 0,
                previous_date: "108/05/02",
                previous_ser_no: "113431271",
                previous_time: "14:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "69/03/29",
                csidno: "A28089165B",
                csmtel: "",
                csname: "馮○思",
                customer_view: "缺醫不可",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "Y",
                group_d: "",
                idmark: {},
                latitude: "0.000000",
                licon: "E",
                longitude: "0.000000",
                marketing_mark: 0,
                previous_date: "108/03/27",
                previous_ser_no: "111035654",
                previous_time: "15:20",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "72/06/27",
                csidno: "F28117231A",
                csmtel: "",
                csname: "陳○宇",
                customer_view: "缺醫不可",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "Y",
                group_d: "",
                idmark: {},
                latitude: "0.000000",
                licon: "E",
                longitude: "0.000000",
                marketing_mark: 0,
                previous_date: "107/08/15",
                previous_ser_no: "96808671",
                previous_time: "13:00",
                previous_year: "2018",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getOneLove = {
    body: {
        detail: [
            {
                ann_time: 0,
                cnt: "9",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "88/02/14",
                csidno: "G28897740D",
                csmtel: "",
                csname: "游○婷",
                customer_view: "一件鍾情",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "",
                group_d: "Y",
                idmark: {},
                latitude: "25.136697",
                licon: "E",
                longitude: "121.460561",
                marketing_mark: 0,
                previous_date: "108/06/25",
                previous_ser_no: "117486435",
                previous_time: "20:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "9",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "88/02/14",
                csidno: "A18111302J",
                csmtel: "",
                csname: "潘○博",
                customer_view: "一件鍾情",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "",
                group_d: "Y",
                idmark: {},
                latitude: "25.136697",
                licon: "E",
                longitude: "121.460561",
                marketing_mark: 0,
                previous_date: "108/06/25",
                previous_ser_no: "117486435",
                previous_time: "20:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "9",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "88/02/14",
                csidno: "F28473701J",
                csmtel: "",
                csname: "陳○",
                customer_view: "一件鍾情",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "",
                group_d: "Y",
                idmark: {},
                latitude: "25.136697",
                licon: "E",
                longitude: "121.460561",
                marketing_mark: 0,
                previous_date: "108/06/25",
                previous_ser_no: "117486435",
                previous_time: "20:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },
            {
                ann_time: 0,
                cnt: "9",
                contact_class: "",
                cr_mark: "",
                cr_rgb: "",
                csbrdy: "88/02/14",
                csidno: "G28897740D",
                csmtel: "",
                csname: "游○婷",
                customer_view: "一件鍾情",
                event_date: "",
                event_ser_no: "",
                event_time: "",
                event_year: "",
                fail_time: 0,
                fee_time: 0,
                group_a: "",
                group_b: "",
                group_c: "",
                group_d: "Y",
                idmark: {},
                latitude: "25.136697",
                licon: "E",
                longitude: "121.460561",
                marketing_mark: 0,
                previous_date: "108/06/25",
                previous_ser_no: "117486435",
                previous_time: "20:00",
                previous_year: "2019",
                record_agcsrt: "",
                undo_marketing: 8,
                vip: "",
                visit_time: 0,
            },

        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryDetail001 = {
    body: [
        {
            category: "精準行銷",
            category_name: "受益量多",
            contact_tel: "7136",
            description: "33~65歲、年繳保費30萬以上。具受益人確認服務機會近半年未購買儲蓄類商品。",
            dev_name: "專案企劃科",
            end_date: "2020-09-04",
            isquarterly: "Y",
            ser_no: "001",
            subcategory: "High客名單",
            upload_date: "2019-06-13",
            upload_file: "",
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}
export const getRealPaying = {
    body: {
        detail: [
            {
                disease_medical_day_pay: '2000元',
                disease_medical_day_limit: '6000元',
                life_insurance_coverage: '50萬',
                csbrdy: "077/05/20",
                csidno: "A28879766J",
                csmtel: "0988335689",
                csname: "王○芳",
                idmark: {
                    source1: "1",
                    source2: "1",
                    source3: "0",
                    source4: "0",
                    source5: "0",
                    source6: "0",
                },
                vip: "",
                visit_time: 0,
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getHonorService = {
    body: {
        "lists": [
            {
                "birthday": "1988-01-01",
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "秦○遠",
                "mobile": "0912123456",
                "vip_room": 0,
                "id": "T16688017I"
            },
            {
                "birthday": "1988-02-02",
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "張李○英",
                "mobile": "0988666123",
                "vip_room": 0,
                "id": "A26899312J"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "傅○威",
                "vip_room": 0,
                "id": "J18661675G"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "林○鳳",
                "vip_room": 0,
                "id": "B28629086E"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "周○憲",
                "vip_room": 0,
                "id": "E18000839A"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "江○嘉",
                "vip_room": 0,
                "id": "A28307285E"
            },
            {
                "check1": "Y",
                "pick_up": 2,
                "vip_lvl": "6",
                "name": "陳盧○鳳",
                "vip_room": 0,
                "id": "L26888222I"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "陳○良",
                "vip_room": 0,
                "id": "N18838050B"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "陳○豐",
                "vip_room": 0,
                "id": "E16843614J"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "林○明",
                "vip_room": 0,
                "id": "Q16799942C"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "戴○龍",
                "vip_room": 0,
                "id": "Q16745750J"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "沈○莙",
                "vip_room": 0,
                "id": "K28741293D"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "簡○林",
                "vip_room": 0,
                "id": "M18660267E"
            },
            {
                "check1": "Y",
                "pick_up": 0,
                "vip_lvl": "5",
                "name": "陳蔡○味",
                "vip_room": 0,
                "id": "T26876938J"
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getPushList = {
    body: {
        "lists": [
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "劉○本",
                "id": "A18782605C",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "白金",
                "vip_lvl": "5",
                "name": "蔡○標",
                "id": "A16660367F",
                "prem": 19,
                "target": "升等目標"
            },
            {
                "target_lvl": "鑽石",
                "vip_lvl": "6",
                "name": "張○清",
                "id": "A16646300A",
                "prem": 26,
                "target": "升等目標"
            },
            {
                "target_lvl": "鑽石",
                "vip_lvl": "6",
                "name": "李○崧",
                "id": "A16866100E",
                "prem": 50,
                "target": "升等目標"
            },
            {
                "target_lvl": "白金",
                "vip_lvl": "5",
                "name": "黃○璋",
                "id": "A18614138B",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "陳○惠",
                "id": "E28794342J",
                "prem": 24,
                "target": "明年降等"
            },
            {
                "target_lvl": "白金",
                "vip_lvl": "5",
                "name": "柯○福",
                "id": "A16725334I",
                "prem": 22,
                "target": "升等目標"
            },
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "王○雄",
                "id": "A18900629A",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "潘○宜",
                "id": "E28717842C",
                "prem": 21,
                "target": "明年降等"
            },
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "張○麟",
                "id": "A18067183F",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "鑽石",
                "vip_lvl": "6",
                "name": "李○科",
                "id": "A16631460A",
                "prem": 32,
                "target": "升等目標"
            },
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "張○盛",
                "id": "A18929916A",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "陳○蕊",
                "id": "E28707348G",
                "prem": 7,
                "target": "明年降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "許○倫",
                "id": "E28707987B",
                "prem": 16,
                "target": "明年降等"
            },
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "張○昌",
                "id": "A18067796C",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "李○錦",
                "id": "E28708196A",
                "prem": 4,
                "target": "明年降等"
            },
            {
                "target_lvl": "白金",
                "vip_lvl": "5",
                "name": "朱○龍",
                "id": "A16760072B",
                "prem": 21,
                "target": "升等目標"
            },
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "張○為",
                "id": "A18705864D",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "鑽石",
                "vip_lvl": "6",
                "name": "陳○中",
                "id": "A16661934C",
                "prem": 16,
                "target": "升等目標"
            },
            {
                "target_lvl": "白金",
                "vip_lvl": "5",
                "name": "王○",
                "id": "A16666635A",
                "prem": 26,
                "target": "升等目標"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "李○芝",
                "id": "E28719482I",
                "prem": 50,
                "target": "明年降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "黃○枝",
                "id": "E28795766F",
                "prem": 5,
                "target": "明年降等"
            },
            {
                "target_lvl": "黃金",
                "vip_lvl": "0",
                "name": "劉○柏",
                "id": "A18857561G",
                "prem": 0,
                "target": "本月降等"
            },
            {
                "target_lvl": "維持黃金",
                "vip_lvl": "5",
                "name": "李○燕",
                "id": "E28717507E",
                "prem": 17,
                "target": "明年降等"
            },
            {
                "target_lvl": "鑽石",
                "vip_lvl": "6",
                "name": "周○奇",
                "id": "A16641223G",
                "prem": 25,
                "target": "升等目標"
            }
        ],
        "updatetime": "201907"
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getWelcomeCeremony = {
    body: {
        "lists": [
            {
                "ym": "201907",
                "name": "王○塗",
                "csidno": "A18905115B",
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "1",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "劉○隆",
                "csidno": "A18944466F",
                "idmark": {
                    "source3": "1",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "0",
                    "source2": "0"
                }
            },
            {
                "ym": "201907",
                "name": "張○凱",
                "csidno": "A18167810F",
                "idmark": {
                    "source3": "1",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "1",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "李○昌",
                "csidno": "A18294598B",
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "0",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "林○辰",
                "csidno": "A18254682G",
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "0",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "王○弘",
                "csidno": "A15660919C",
                "idmark": {}
            },
            {
                "ym": "201907",
                "name": "陳○芳",
                "csidno": "A26780919B",
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "1",
                    "source1": "1",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "吳○琴",
                "csidno": "A26714090A",
                "idmark": {}
            },
            {
                "ym": "201907",
                "name": "謝陳○琴",
                "csidno": "A26883608F",
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "1",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "周○華",
                "csidno": "A26820763H",
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "0",
                    "source2": "1"
                }
            },
            {
                "ym": "201907",
                "name": "戚○官",
                "csidno": "A26844413A",
                "idmark": {}
            },
            {
                "ym": "201907",
                "name": "廖○億",
                "csidno": "C18768708E",
                "idmark": {
                    "source3": "1",
                    "source4": "0",
                    "source5": "1",
                    "source6": "1",
                    "source1": "1",
                    "source2": "1"
                }
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCathayFamily = {
    body: {
        "lists": [
            {
                "vip_lvl": "6",
                "apply": "Y",
                "name": "施○堂",
                "id": "A17697543H"
            },
            {
                "vip_lvl": "7",
                "apply": "Y",
                "name": "曹○傳",
                "id": "A18901279I"
            },
            {
                "vip_lvl": "7",
                "apply": "Y",
                "name": "許○翔",
                "id": "A18131260C"
            },
            {
                "vip_lvl": "7",
                "apply": "Y",
                "name": "林○航",
                "id": "A18149327D"
            },
            {
                "vip_lvl": "7",
                "apply": "Y",
                "name": "顏○華",
                "id": "A26950861F"
            },
            {
                "vip_lvl": "6",
                "apply": "Y",
                "name": "石○菁",
                "id": "A28601064B"
            },
            {
                "vip_lvl": "6",
                "apply": "Y",
                "name": "張○文",
                "id": "A28788142A"
            },
            {
                "vip_lvl": "7",
                "apply": "Y",
                "name": "蔡○梅",
                "id": "A28702682B"
            },
            {
                "vip_lvl": "6",
                "apply": "Y",
                "name": "黃○鷹",
                "id": "A28730856A"
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getHealthCeremony = {
    body: {
        "lists": [
            {
                "qualification": "結婚大喜",
                "name": "戴○鳳",
                "apply_time": "2018-11-25",
                "id": "L28676424B",
                "member_name": "詹○雲",
                "present": "HOTEL COZZI和逸飯店‧高雄中山館平日雙人客房住宿券(含早餐，價值$2500元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "喜獲子女",
                "name": "劉○華",
                "apply_time": "2018-12-10",
                "id": "N26631584C",
                "member_name": "王○靖",
                "present": "HOTEL COZZI和逸飯店‧高雄中山館平日雙人客房住宿券(含早餐，價值$2500元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "結婚大喜",
                "name": "潘○禎",
                "apply_time": "2018-11-30",
                "id": "H28676409I",
                "member_name": "吳○翰",
                "present": "國泰健管日常保健營養品(價值$2500元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "喜獲子女",
                "name": "陳○秀",
                "apply_time": "2019-01-10",
                "id": "H28692763J",
                "member_name": "蔡○宏",
                "present": "國泰健管心血管保健組營養品(價值$5000元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "結婚大喜",
                "name": "陳○樹",
                "apply_time": "2018-11-29",
                "id": "A18609170G",
                "member_name": "陳○樺",
                "present": "HOTEL COZZI和逸飯店‧台南西門館平日雙人客房住宿券(不含早餐，價值$2200元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "結婚大喜",
                "name": "劉○源",
                "apply_time": "2018-11-23",
                "id": "Y18663083H",
                "member_name": "劉○文",
                "present": "HOTEL COZZI和逸飯店‧台南西門館平日雙人客房住宿券(不含早餐，價值$2200元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "喜獲子女",
                "name": "楊○華",
                "apply_time": "2019-01-31",
                "id": "N28655738C",
                "member_name": "施○承",
                "present": "HOTEL COZZI和逸飯店‧台南西門館平日雙人客房住宿券(不含早餐，價值$2200元)",
                "relationship": "2",
                "quatification": ""
            },
            {
                "qualification": "喜獲子女",
                "name": "楊○華",
                "apply_time": "2019-01-31",
                "id": "N28655738C",
                "member_name": "施○緯",
                "present": "HOTEL COZZI和逸飯店‧台南西門館平日雙人客房住宿券(不含早餐，價值$2200元)",
                "relationship": "2",
                "quatification": ""
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getFreeHealthCheck = {
    body: {
        "lists": [
            {
                "birthday": "1955-11-26",
                "mobile": "",
                "cs_idno": "A17666969E",
                "start_period": 10812,
                "idmark": {
                    "source3": "0",
                    "source4": "0",
                    "source5": "0",
                    "source6": "0",
                    "source1": "0",
                    "source2": "1"
                },
                "cs_name": "沈○豐",
                "age": 63,
                "email": ""
            }
        ]
    },
    header: {
        "message": "查詢成功",
        "userId": "C18768708E",
        "userDeviceIp": "10.87.23.52",
        "status": "200"
    },
}

export const getForeignCurrencyHandleDiscount = {
    body: {
        "lists": [
            {
                "birthday": "1981-09-22",
                "pre_deadline": "2019-08-06",
                "mobile": "0983***703",
                "idmark": {},
                "pre_star": "2019-07-23",
                "csname": "劉○祥",
                "ceapcno": "A18686454O",
                "age": 37
            },
            {
                "birthday": "1943-04-14",
                "pre_deadline": "2019-08-06",
                "mobile": "0939***793",
                "idmark": {},
                "pre_star": "2019-07-23",
                "csname": "黃○雄",
                "ceapcno": "A10213074P",
                "age": 75
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryDetail002 = {
    body: [
        {
            category: "精準行銷",
            category_name: "缺醫不可 ",
            contact_tel: "7136",
            description: "33~65歲、年繳保費30萬以上。具受益人確認服務機會近半年未購買儲蓄類商品。",
            dev_name: "專案企劃科",
            end_date: "2020-09-04",
            isquarterly: "Y",
            ser_no: "002",
            subcategory: "High客名單",
            upload_date: "2019-06-13",
            upload_file: "",
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryDetail003 = {
    body: [
        {
            category: "精準行銷",
            category_name: "一件鍾情",
            contact_tel: "7136",
            description: "0~41歲。未購買重疾險，購買機會相對高(模型預測)，核保機會相對高。",
            dev_name: "專案企劃科",
            end_date: "2020-09-04",
            isquarterly: "Y",
            ser_no: "003",
            subcategory: "High客名單",
            upload_date: "2019-06-13",
            upload_file: "",
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getCategoryDetail023 = {
    body: [
        {
            category: "服務/權益",
            category_name: "異動後實質接觸明細",
            contact_tel: "",
            description: "1.保單號碼開頭為0、1、含英文字母及部分9100開頭者，為原專寶專福的服務件，有疑問請洽保費部保費企劃科(02)27551399#19162.如有更新要保人資料可計入實質接觸項目",
            dev_name: "業務企劃科",
            isquarterly: "Y",
            ser_no: "023",
            subcategory: "服務類",
            upload_file: "保戶拜訪SOP(含疏遠件說明).pdf",
        },
    ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const allUnitdetachment = {
    body: {
        query_stats_n_lev1:
        [

            {
                ceadcd: "0",
                ceadnm: "合計",
                child: false,
                n_ag: 29022,
                n_cust: 589917,
                n_done1: 121252,
                n_done2: 250508,
                n_rate: 63.02,
                n_remain: 218157
            },
            {
                ceadcd: "1",
                ceadnm: "專招",
                child: true,
                n_ag: 7665,
                n_cust: 114108,
                n_done1: 20263,
                n_done2: 52232,
                n_rate: 63.53,
                n_remain: 41613,
            },
            {
                ceadcd: "4",
                ceadnm: "展業",
                child: true,
                n_ag: 21357,
                n_cust: 475809,
                n_done1: 100989,
                n_done2: 198276,
                n_rate: 62.9,
                n_remain: 176544
            },
        ]

    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"
    },
}

export const newcomerDialinWithin = {
    body: {
        query_stats_e_lev1:
        [
          {
            ceadcd: "0",
            ceadnm: "合計",
            child: false,
            e_ag: 2396,
            e_cust: 128790,
            e_done1: 73291,
            e_done2: 1696,
            e_rate: 58.22,
            e_remain: 53803,
            h_ag: 0,
            h_cust: 0,
            h_done1: 0,
            h_done2: 0,
            h_rate: 0,
            h_remain: 0
          },
          {
            ceadcd: "1",
            ceadnm: "專招",
            child: true,
            e_ag: 782,
            e_cust: 44800,
            e_done1: 17017,
            e_done2: 1490,
            e_rate: 41.31,
            e_remain: 26293,
            h_ag: 0,
            h_cust: 0,
            h_done1: 0,
            h_done2: 0,
            h_rate: 0,
            h_remain: 0
          },
          {
            ceadcd: "4",
            ceadnm: "展業",
            child: true,
            e_ag: 1614,
            e_cust: 83990,
            e_done1: 56274,
            e_done2: 206,
            e_rate: 67.25,
            e_remain: 27510,
            h_ag: 0,
            h_cust: 0,
            h_done1: 0,
            h_done2: 0,
            h_rate: 0,
            h_remain: 0
          }
        ]
    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"
    },
}


export const getChangeDetail = {
    body: {
        notice_list:
        [
          {
            ceapcnm: "張○娟",
            ceapcno: "S28683426C",
            celpscs_nm: "繳清滿期件",
            cenxpdt: "1911-01-01",
            ceplcno: "3979899555",
            clcid: "",
            clcno: "EB1399A",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095229787"
          },
          {
            ceapcnm: "陳○廉",
            ceapcno: "E16772740J",
            ceclcno_old: "EB13038",
            celpscs_nm: "正常",
            cenxpdt: "2019-12-25",
            ceplcno: "1005041841",
            clcid: "",
            clcno: "EB13149",
            code_nm: "2年內新人",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095226352"
          },
          {
            ceapcnm: "劉○惠",
            ceapcno: "S28639759F",
            ceclcno_old: "EB13037",
            celpscs_nm: "正常",
            cenxpdt: "2019-06-12",
            ceplcno: "7912732201",
            clcid: "",
            clcno: "EB13099",
            code_nm: "其他業務同仁",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095243146"
          },   
          {
            ceapcnm: "蘇○麗",
            ceapcno: "S28644501E",
            ceclcno_old: "EB13037",
            celpscs_nm: "繳清滿期件",
            cenxpdt: "1911-01-01",
            ceplcno: "7901651358",
            clcid: "",
            clcno: "EB13036",
            code_nm: "其他業務同仁",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095241993"
          },
          {
            ceapcnm: "王○輝",
            ceapcno: "E18701489G",
            ceclcno_old: "EB13105",
            celpscs_nm: "正常",
            cenxpdt: "2019-06-13",
            ceplcno: "1100131413",
            clcid: "",
            clcno: "EB1319A",
            code_nm: "其他業務同仁",
            fin: "1",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095026556"
          },
          {
            ceapcnm: "周○琳",
            ceapcno: "R28851814E",
            ceclcno_old: "EB13037",
            celpscs_nm: "正常",
            cenxpdt: "1911-01-01",
            ceplcno: "7908590915",
            clcid: "",
            clcno: "EB13153",
            code_nm: "2年內新人",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095242589"
          },  
          {
            ceapcnm: "王○輝",
            ceapcno: "E18701489G",
            ceclcno_old: "EB13105",
            celpscs_nm: "正常",
            cenxpdt: "2019-06-13",
            ceplcno: "1100131422",
            clcid: "",
            clcno: "EB1319A",
            code_nm: "其他業務同仁",
            fin: "1",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095026557"
          },
          {
            ceapcnm: "曾○雲",
            ceapcno: "E28610729G",
            ceclcno_old: "EB13037",
            celpscs_nm: "終身險滿期",
            cenxpdt: "1911-01-01",
            ceplcno: "5506031518",
            clcid: "",
            clcno: "EB13036",
            code_nm: "其他業務同仁",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095230166"
          },  
          {
            ceapcnm: "林○瑩",
            ceapcno: "E28816140D",
            celpscs_nm: "繳清滿期件",
            cenxpdt: "2000-12-31",
            ceplcno: "1001272831",
            clcid: "",
            clcno: "EB1399A",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095225578"
          },   
          {
            ceapcnm: "陳○廉",
            ceapcno: "E16772740J",
            ceclcno_old: "EB13038",
            celpscs_nm: "正常",
            cenxpdt: "2019-12-25",
            ceplcno: "1005041850",
            clcid: "",
            clcno: "EB13149",
            code_nm: "2年內新人",
            fin: "0",
            idmark: "0",
            last_visitday: "2019-12-31",
            visit_no: "G095226353"
          },                
        ]
    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"        
    },
}

export const getChangePeople = {
    body: {
        clcno_agnts:
        [
            {
                clcid: "T28732574F",
                clcid_nm: "張○瑩",
                clcno: "EB10046"
            },
            {
                clcid: "S26688555I",
                clcid_nm: "孫○臨",
                clcno: "EB11AA2"
            }, 
            {
                clcid: "S26688698E",
                clcid_nm: "蔡○華",
                clcno: "EB13017"
            },
            {
                clcid: "E18858997C",
                clcid_nm: "顏○峰",
                clcno: "EB13021"
            },
            {
                clcid: "E26675964B",
                clcid_nm: "蘇○英",
                clcno: "EB13025"
            },
            {
                clcid: "E28750116D",
                clcid_nm: "陳○梅",
                clcno: "EB13033"
            },
            {
                clcid: "E28088449A",
                clcid_nm: "翁○婕",
                clcno: "EB13036"
            },
            {
                clcid: "S28624857J",
                clcid_nm: "簡○美",
                clcno: "EB13038"
            },
            {
                clcid: "D28663044A",
                clcid_nm: "王○麗",
                clcno: "EB13049"
            },
            {
                clcid: "S26688555I",
                clcid_nm: "孫○臨",
                clcno: "EB13055"
            },                                                           
        ]
    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"        
    },
}

export const getChangeTrace = {
    body: {
        change_trace:
        [
          {
            cedvnm: "專招",
            cedvno: "1",
            cscontacted_1y: 0,
            cscontacted_6: 4656,
            cscontacted_12: 0,
            csnoncontacted_r: 5714,
            rate_1y: 0,
            rate_6: 44.9,
            rate_12: 0,
            total: 10370
          },
          {
            cedvnm: "展業",
            cedvno: "4",
            cscontacted_1y: 0,
            cscontacted_6: 5907,
            cscontacted_12: 0,
            csnoncontacted_r: 16667,
            rate_1y: 0,
            rate_6: 26.2,
            rate_12: 0,
            total: 22574
          },
          {
            cedvnm: "合計",
            cedvno: "合計",
            cscontacted_1y: 0,
            cscontacted_6: 10563,
            cscontacted_12: 0,
            csnoncontacted_r: 22381,
            rate_1y: 0,
            rate_6: 32.1,
            rate_12: 0,
            total: 32944
          }
        ]
    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"        
    },
}

export const queryUnitBulletinEffect = {
    body: {
        onenews:
        [
          {
            "end_date": "2020-07-10",
            "ser_no": "001",
            "ddate": "2019-07-10 00:00:00.0",
            "subject": "【教案】CRM2.0試點宣導-8工教案",
            "words": "CRM2.0揪竟有什麼新功能呢?可以下載附件看明白~",
            "ceadcd": "9N00000",
            "star_date": "2019-07-10",
            "upd_id": "A125685019",
            "filename": "試點規劃-8工教案",
            "ta_count": "27243",
            "http": "https://crm.cathaylife.com.tw/eisn/upload/teaching/upload/940/part1.pdf",
            "link_way": "2",
            "upd_time": "2019-07-10 00:00:00.0",
            "emp_nm": "黃炯銘",
            "dvno": "9N00200",
            "class": "1",
            "dvnm": "數位支援科",
            "emp_id": "A125685019"
          }
        ],
        dev_list:
        [
          {
            "ceadcd": "AC00000",
            "cedvno": "AH42400",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業二課四區",
            "link_percentage": "0.0073413400"
          },
          {
            "ceadcd": "AC00000",
            "cedvno": "AH42100",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業二課一區",
            "link_percentage": "0.0073413400"
          },
          {
            "ceadcd": "AC00000",
            "cedvno": "AH42000",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業二課",
            "link_percentage": "0.0073413400"
          },
          {
            "ceadcd": "AC00000",
            "cedvno": "AH40000",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）",
            "link_percentage": "0.0073413400"
          },
          {
            "ceadcd": "AC00000",
            "cedvno": "AH44G00",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業四課Ｇ區",
            "link_percentage": "0.0073413400"
          },
          {
            "ceadcd": "AC00000",
            "cedvno": "AH44F00",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業四課Ｆ區",
            "link_percentage": "0.0073413400"             
          },  
          {
            "ceadcd": "AC00000",
            "cedvno": "AH44E00",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業四課Ｅ區",
            "link_percentage": "0.0073413400"
          },   
          {
            "ceadcd": "AC00000",
            "cedvno": "AH44D00",
            "click_download_percentage": "0.0",
            "cedvnm": "展業信義通訊處（一）展業四課Ｄ區",
            "link_percentage": "0.0073413400"
          },                            
        ] 
    },
    header: {
        "message": "查詢成功",
        "userId": "C18768708E",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const forcedTransferPersonnel = {
    body: [
            {
            a_ag: 1300,
            a_cust: 158261,
            a_done1: 113960,
            a_done2: 9258,
            a_rate: 77.86,
            a_remain: 35043,
            ceadcd: "0",
            ceadnm: "合計",
            child: false
            },
            {
            a_ag: 573,
            a_cust: 50377,
            a_done1: 31696,
            a_done2: 5754,
            a_rate: 74.34,
            a_remain: 12927,
            ceadcd: "1",
            ceadnm: "專招",
            child: true
            },
            {
            a_ag: 727,
            a_cust: 107884,
            a_done1: 82264,
            a_done2: 3504,
            a_rate: 79.5,
            a_remain: 22116,
            ceadcd: "4",
            ceadnm: "展業",
            child: true
            }
         ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"        
    },
}

export const getmandatoryAllocationSummary = {
    body: {
        query_stats_lev1:
        [
          {
            a_cust: 158261,
            a_done: 123218,
            a_rate: 77.86,
            abc_cust: 876968,
            abc_done: 570037,
            abc_rate: 65,
            c_cust: 128790,
            c_done: 74987,
            c_rate: 58.22,
            ceadcd: "0",
            ceadnm: "合計",
            child: false,
            n_cust: 589917,
            n_done: 371832,
            n_rate: 63.03
          },
          {
            a_cust: 50377,
            a_done: 37450,
            a_rate: 74.34,
            abc_cust: 209285,
            abc_done: 128467,
            abc_rate: 61.38,
            c_cust: 44800,
            c_done: 18507,
            c_rate: 41.31,
            ceadcd: "1",
            ceadnm: "專招",
            child: true,
            n_cust: 114108,
            n_done: 72510,
            n_rate: 63.55
          },
          {
            a_cust: 107884,
            a_done: 85768,
            a_rate: 79.5,
            abc_cust: 667683,
            abc_done: 441570,
            abc_rate: 66.13,
            c_cust: 83990,
            c_done: 56480,
            c_rate: 67.25,
            ceadcd: "4",
            ceadnm: "展業",
            child: true,
            n_cust: 475809,
            n_done: 299322,
            n_rate: 62.91
          }
        ]        
    },
    header: {
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"       
    },
}

export const setKeyWordLog = {
    body: {
        agidno: "S18990655I",
        searchkeyword: "愛清潔，有禮貌"       
    },
    header: {
        userDeviceIp: "1.2.3.4",
        userId: "S18990655I"        
    },
}

export const queryOldClickRate = {
    body: {
        "report": [
            {
                ceadcd: "AC00000",
                class: "3",
                click_note: "查無資料",
                click_percentage: "0",
                ddate: "2019-07-29 15:09:32.30273",
                dvnm: "展信義二１",
                dvno: "AH42100",
                emp_id: "C10797445C",
                emp_nm: "廖○億",
                end_date: "2019-08-12",
                filename: "",
                http: "",
                link_way: "0",
                news_status: "0",
                ser_no: "009",
                star_date: "2019-07-29",
                subject: "222",
                ta_count: 1,
                upd_id: "C10797445C",
                upd_nm: "廖○億",
                upd_time: "2019-08-02 16:57:07.228976",
                words: "ddd",
            },
            {
                ceadcd: "AC00000",
                class: "3",
                click_note: "查無資料",
                click_percentage: "0",
                ddate: "2019-07-29 15:16:01.647737",
                dvnm: "展信義二１",
                dvno: "AH42100",
                emp_id: "C10797445C",
                emp_nm: "廖○億",
                end_date: "2019-07-31",
                filename: "",
                http: "",
                link_way: "0",
                news_status: "0",
                ser_no: "010",
                star_date: "2019-07-29",
                subject: "你們是以個人電腦市長",
                ta_count: 1,
                upd_id: "C10797445C",
                upd_nm: "廖○億",
                upd_time: "2019-08-02 16:56:30.784095",
                words: "是、但⋯⋯你在的他他有有以都都也你但在在的的的的的的的的的的的他他6765&654*^%%$#@！～",
            },
        ]       
    },
    header: {
        "message": "查詢成功",
        "userId": "N18821725E",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const queryClickRate = {
    body: {
        "report": [
            {
                ceadcd: "AC00000",
                click_percentage: "0",
                ddate: "2019-08-16 14:13:53.406499",
                dvnm: "展信義二１",
                dvno: "AH42100",
                emp_id: "C10797445C",
                emp_nm: "廖○億",
                end_date: "2019-08-23",
                filename: "成功回到小額調撥.PNG",
                http: "",
                link_way: "2",
                news_status: "",
                percentage_list: {
                    click_download_note: "查無資料",
                    click_download_percentage: "0",
                    click_note: "查無資料",
                    click_percentage: "0",
                    ser_no: "045",
                },
                ser_no: "045",
                star_date: "2019-08-22",
                subject: "test",
                ta_count: 132,
                upd_id: "C10797445C",
                upd_nm: "廖○億",
                upd_time: "2019-08-16 14:13:53.406499",
                words: "123",
            },
            {
                ceadcd: "AC00000",
                click_percentage: "0",
                ddate: "2019-08-16 14:13:53.406499",
                dvnm: "展信義二１",
                dvno: "AH42100",
                emp_id: "C10797445C",
                emp_nm: "廖○億",
                end_date: "2019-10-23",
                filename: "成功回到小額調撥.PNG",
                http: "",
                link_way: "2",
                news_status: "",
                percentage_list: {
                    click_download_note: "查無資料",
                    click_download_percentage: "0",
                    click_note: "查無資料",
                    click_percentage: "0",
                    ser_no: "045",
                },
                ser_no: "045",
                star_date: "2019-10-22",
                subject: "test",
                ta_count: 132,
                upd_id: "C10797445C",
                upd_nm: "大帥哥",
                upd_time: "2019-08-16 14:13:53.406499",
                words: "123",
            },
            {
                ceadcd: "AC00000",
                click_percentage: "0",
                ddate: "2019-08-16 14:13:53.406499",
                dvnm: "展信義二１",
                dvno: "AH42100",
                emp_id: "C10797445C",
                emp_nm: "廖○億",
                end_date: "2019-09-23",
                filename: "成功回到小額調撥.PNG",
                http: "",
                link_way: "2",
                news_status: "",
                percentage_list: {
                    click_download_note: "查無資料",
                    click_download_percentage: "0",
                    click_note: "查無資料",
                    click_percentage: "0",
                    ser_no: "045",
                },
                ser_no: "045",
                star_date: "2019-09-22",
                subject: "test",
                ta_count: 132,
                upd_id: "C10797445C",
                upd_nm: "王小花",
                upd_time: "2019-08-16 14:13:53.406499",
                words: "123",
            },
        ]        
    },
    header: {
        "message": "查詢成功",
        "userId": "N18821725E",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const getChangeUpdateReprot = {
    body: {
        
    },
    header: {
        "message": "查詢成功",
        "userId": "N18821725E",
        "userDeviceIp": "10.87.23.52",
        "status": "200"           
    },
}

export const queryconditions = {
    body: [{
                agnt_id: "L18660015B",
                agnt_name: "劉○偉",
                applydate: "2019-07-29",
                cedvnm: "專招高華通訊處（一）",
                condition_status: "發佈中",
                dev_nm: "通訊處經理",
                devfilter_name: "測試單位條件篩選設定",
                devfilter_serno: "003",
                devno: "EA10000",
                end_date: "2019-09-03",
                field_name: "idage-sex",
                foption: "min:20/max:29-2",
                modifydate: "2019-07-30",
                news_status: "1",
                option_ch: "年齡:20歲~29歲;性別:女",
                percentage_list: [],
                ta_count: 0,
                target_cs: "單位所有人",
                upload_date: "2019-08-01"        
            },
            {
                agnt_id: "L18660015B",
                agnt_name: "劉○偉",
                applydate: "2019-07-29",
                cedvnm: "專招高華通訊處（一）",
                condition_status: "發佈中",
                dev_nm: "通訊處經理",
                devfilter_name: "測試新增單位條件篩選",
                devfilter_serno: "004",
                devno: "EA10000",
                end_date: "2019-08-15",
                field_name: "idage-sex-birthmonth",
                foption: "min:20/max:29-2-12",
                modifydate: "2019-07-29",
                news_status: "1",
                option_ch: "年齡:20歲~29歲;性別:女;生日月份:十二月",
                percentage_list: [],
                ta_count: 0,
                target_cs: "單位所有人",
                upload_date: "2019-07-29"                
            }
           ],
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "L18660015B"        
    },
}

export const getUnitCustCount = {
    body: {
        dev_list:
        [
            {
                ceadcd: "E100000",
                cedvnm: "專招高華通訊處（一）豐華推展處",
                cedvno: "EA15800",
                ta_aglist:{
                    agid: "S28844534D",
                    cust_count: "0",
                    div_no: "EA15800"
                }
            },
            {
                ceadcd: "E100000",
                cedvnm: "專招高華通訊處（一）馥裕推展處",
                cedvno: "EA15700",
                ta_aglist: {
                    agid: "E28689201C",
                    cust_count: "0",
                    div_no: "EA15700"
                }
            },
            {
                ceadcd: "E100000",
                cedvnm: "專招高華通訊處（一）薪發推展處",
                cedvno: "EA15400",
                ta_aglist: {
                    agid: "S28765853D",
                    cust_count: "0",
                    div_no: "EA15400",
                }
            },
            {
                ceadcd: "E100000",
                cedvnm: "專招高華通訊處（一）宏銘推展處",
                cedvno: "EA14900",
                ta_aglist: {
                    agid: "T28775110B",
                    cust_count: "0",
                    div_no: "EA14900",
                }
            },
            {
                ceadcd: "E100000",
                cedvnm: "專招高華通訊處（一）雙銓推展處",
                cedvno: "EA11700",
                ta_aglist: {
                    agid: "E18872684A",
                    cust_count: "0",
                    div_no: "EA11700",
                }
            },
            {
                ceadcd: "E100000",
                cedvnm: "專招高華通訊處（一）凱麟推展處",
                cedvno: "EA11500",
                ta_aglist: {
                    agid: "E28985881G",
                    cust_count: "0",
                    div_no: "EA11500"
                }
            }
        ]
    },
    header: {
        message: "查無資料",
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "L18660015B"        
    },
}

export const getCathayFamilyPrint = {
    body: {
        "applyno": "00000061"
    },
    header: {
        "message": "查詢成功",
        "userId": "A28978309I",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const getEffective = {
    body: {
        dev_list:[
            {
                agnt_count: "",
                ceadcd: "E100000",
                cedvnm: "專招高暉通訊處（二）全勝推展處",
                cedvno: "EB13100",
                click_percentage: ""
            }
        ],
        oneconditions:[
            {
                agnt_id: "S18990655I",
                agnt_name: "呂○憲",
                applydate: "2019-08-06",
                cedvnm: "專招高暉通訊處（二）",
                devfilter_name: "45245",
                devfilter_serno: "025",
                devno: "EB10000",
                end_date: "2019-08-08",
                field_name: "idage",
                foption: "min:10/max:19",
                modifydate: "2019-08-06",
                option_ch: "年齡:10歲~19歲",
                ta_count: 0,
                target_cs: "1",
                upload_date: "2019-08-06"
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "S18990655I"        
    },
}

export const getEffective1 = {
    body: {
        dev_list:[
            {
                agnt_count: "",
                ceadcd: "E100000",
                cedvnm: "專招高暉通訊處（二）耀陞推展處",
                cedvno: "EB13000",
                click_percentage: ""
            }
        ],
        oneconditions:[
            {
                agnt_id: "S18990655I",
                agnt_name: "呂○憲",
                applydate: "2019-08-06",
                cedvnm: "專招高暉通訊處（二）",
                devfilter_name: "45245",
                devfilter_serno: "025",
                devno: "EB10000",
                end_date: "2019-08-08",
                field_name: "idage",
                foption: "min:10/max:19",
                modifydate: "2019-08-06",
                option_ch: "年齡:10歲~19歲",
                ta_count: 0,
                target_cs: "1",
                upload_date: "2019-08-06"
            }
        ]
    },
    header: {
        
    },
}

export const getWarrantyShouldReceiveNotReceive = {
    body: {
        "lists": [
            {
                "birthday": "1989-04-04",
                "pay_date": "2016-12-24",
                "policy_no": "7507467622",
                "pay_amt": 60000,
                "apc_id": "N21612460J",
                "mobile": "0912123456",
                "data_kind": "2",
                "curr": "NTD",
                "prod_id": "HN1",
                "age": 30,
                "apc_name": "羅○秋"
            },
            {
                "birthday": "1989-01-01",
                "pay_date": "2018-12-31",
                "policy_no": "9123068022",
                "pay_amt": 21420,
                "apc_id": "N13420747P",
                "mobile": "0988123456",
                "data_kind": "2",
                "curr": "NTD",
                "prod_id": "IU",
                "age": 30,
                "apc_name": "黃○倫"
            },
            {
                "birthday": "1988-01-01",
                "pay_date": "2015-02-28",
                "policy_no": "5566524807",
                "pay_amt": 25135,
                "apc_id": "Q10369135D",
                "mobile": "0963123456",
                "data_kind": "1",
                "curr": "NTD",
                "prod_id": "AM_",
                "age": 31,
                "apc_name": "韓○吉"
            },
            {
                "birthday": "1988-01-01",
                "pay_date": "2015-02-28",
                "policy_no": "5566524807",
                "pay_amt": 25135,
                "apc_id": "Q10369135D",
                "mobile": "0963123456",
                "data_kind": "1",
                "curr": "NTD",
                "prod_id": "AY_",
                "age": 31,
                "apc_name": "韓○吉"
            },
            {
                "birthday": "1988-01-01",
                "pay_date": "2015-02-28",
                "policy_no": "5566524807",
                "pay_amt": 25135,
                "apc_id": "Q10369135D",
                "mobile": "0963123456",
                "data_kind": "1",
                "curr": "NTD",
                "prod_id": "AC_",
                "age": 31,
                "apc_name": "韓○吉"
            },
            {
                "birthday": "1988-01-01",
                "pay_date": "2015-02-28",
                "policy_no": "5566524807",
                "pay_amt": 25135,
                "apc_id": "Q10369135D",
                "mobile": "0963123456",
                "data_kind": "1",
                "curr": "NTD",
                "prod_id": "AA_",
                "age": 31,
                "apc_name": "韓○吉"
            },
            {
                "birthday": "1988-01-01",
                "pay_date": "2015-02-28",
                "policy_no": "5566524807",
                "pay_amt": 25135,
                "apc_id": "Q10369135D",
                "mobile": "0963123456",
                "data_kind": "1",
                "curr": "NTD",
                "prod_id": "AB_",
                "age": 31,
                "apc_name": "韓○吉"
            },
            {
                "birthday": "1988-01-01",
                "pay_date": "2015-02-28",
                "policy_no": "5566524807",
                "pay_amt": 25135,
                "apc_id": "Q10369135D",
                "mobile": "0963123456",
                "data_kind": "1",
                "curr": "NTD",
                "prod_id": "A0_",
                "age": 31,
                "apc_name": "韓○吉"
            }
        ]
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}

export const getFullAnnuityNotHandle = {
    body: {
        lists: [
            {
                ceapcnm: "高○蕙",
                cebnfnm: "高○蕙",
                id: "C10797445C",
                mobile: "",
                money: "新台幣",
                plcno: "3801875431",
                plcymd: "105/03/21",
                type: "滿期金",
            },
            {
                ceapcnm: "趙小名",
                cebnfnm: "趙小名",
                id: "E25121234L",
                mobile: "0912345789",
                money: "新台幣",
                plcno: "3851275303",
                plcymd: "93/08/16",
                type: "年金"
            },
            {
                ceapcnm: "許大名",
                cebnfnm: "許大名",
                id: "J13285739J",
                mobile: "",
                money: "新台幣",
                plcno: "9156290936",
                plcymd: "93/10/23",
                type: "年金"
            },                        
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}


export const getUnpaidCheck = {
    body: {
        detail: [
            {
                ceapcnm: "未辦人",
                cebnfnm: "未辦人",
                checkamount: 290,
                checkdate: "96-09-29",
                checknum: "00855410",
                id: "C10797445C",
                mobile: "",
                plcno: "3801875431",
                type: "壽險特約內容變更",
            },
            {
                ceapcnm: "陳先生",
                cebnfnm: "陳先生",
                checkamount: 145,
                checkdate: "97-01-04",
                checknum: "00768373",
                id: "J13285739J",
                mobile: "",
                plcno: "9156290936",
                type: "壽險特約內容變更",
            },
            {
                ceapcnm: "戴小姐",
                cebnfnm: "戴小姐",
                checkamount: 142,
                checkdate: "95-10-04",
                checknum: "00768373",
                id: "E25121234L",
                mobile: "0912345789",
                plcno: "3851275303",
                type: "壽險解約"
            },                        
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}




export const isSatisfactionSurveyFinish = {
    body: {
        isfinish: "0"
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.62",
        userId: "P24162078P"  
    },
}

export const getLongTermCare  = {
    body: {
        "detail": [
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "source": "",
                "csname": "凌○華",
                "contact_class": "",
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "",
                "sub_cls_nm2": "",
                "undo_marketing": 8,
                "vip": "",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "",
                "sub_cls_nm3": "",
                "previous_year": "",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "42/06/16",
                "sub_cls_nm6": "",
                "cnt": "3",
                "event_year": "",
                "record_agcsrt": "",
                "record_symbol": "",
                "csidno": "D20743301A",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "source": "",
                "csname": "宋○穎",
                "contact_class": "",
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "",
                "sub_cls_nm2": "",
                "undo_marketing": 8,
                "vip": "",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "",
                "sub_cls_nm3": "",
                "previous_year": "",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "55/08/19",
                "sub_cls_nm6": "",
                "cnt": "",
                "event_year": "",
                "record_agcsrt": "",
                "record_symbol": "",
                "csidno": "E10351905C",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "08:00",
                "source": "",
                "csname": "呂○金",
                "contact_class": "",
                "previous_ser_no": "97824052",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "人工/自繳",
                "sub_cls_nm2": "滿期金/年金",
                "undo_marketing": 8,
                "vip": "黃金",
                "customer_view": "超值服務",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "107/08/30",
                "sub_cls_nm3": "保全",
                "previous_year": "2018",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "50/02/10",
                "sub_cls_nm6": "",
                "cnt": "",
                "event_year": "",
                "record_agcsrt": "客戶服務",
                "record_symbol": "003",
                "csidno": "P24162078P",
                "marketing_mark": 0,
                "event_time": ""
            }
        ]        
    },
    header: {
        "message": "查詢成功",
        "userId": "P24162078P",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const getWillStopEffect = {
    body: {
        "detail": [
            {
                "licon": "B",
                "latitude": "0.000000",
                "idmark": {},
                "csmtel": "",
                "previous_time": "14:00",
                "csname": "王○新",
                "contact_class": "",
                "ann_time": 2,
                "fail_time": 0,
                "previous_ser_no": "116620638",
                "event_date": "",
                "event_ser_no": "",
                "group_d": "",
                "undo_marketing": 8,
                "group_a": "",
                "vip": "白金",
                "customer_view": "受益量多",
                "cr_rgb": "",
                "group_c": "",
                "longitude": "0.000000",
                "group_b": "Y",
                "previous_date": "108/06/24",
                "cr_mark": "",
                "previous_year": "2019",
                "visit_time": 0,
                "csbrdy": "60/05/12",
                "cnt": "3",
                "event_year": "",
                "fee_time": 3,
                "record_agcsrt": "客戶服務",
                "csidno": "A16973754L",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "licon": "E",
                "latitude": "0.000000",
                "idmark": {},
                "csmtel": "0227551399",
                "previous_time": "12:20",
                "csname": "張○嘉",
                "contact_class": "",
                "ann_time": 2,
                "fail_time": 2,
                "previous_ser_no": "97824337",
                "event_date": "",
                "event_ser_no": "",
                "group_d": "",
                "undo_marketing": 8,
                "group_a": "",
                "vip": "",
                "customer_view": "樂活享富",
                "cr_rgb": "",
                "group_c": "",
                "longitude": "0.000000",
                "group_b": "",
                "previous_date": "107/08/30",
                "cr_mark": "",
                "previous_year": "2018",
                "visit_time": 0,
                "csbrdy": "61/07/24",
                "cnt": "",
                "event_year": "",
                "fee_time": 0,
                "record_agcsrt": "客戶服務",
                "csidno": "B29829188L",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "licon": "C",
                "latitude": "25.050353",
                "idmark": {},
                "csmtel": "0227551399",
                "previous_time": "15:30",
                "csname": "沈○惠",
                "contact_class": "",
                "ann_time": 0,
                "fail_time": 3,
                "previous_ser_no": "118545330",
                "event_date": "",
                "event_ser_no": "",
                "group_d": "",
                "undo_marketing": 9,
                "group_a": "",
                "vip": "",
                "customer_view": "保障GO讚",
                "cr_rgb": "",
                "group_c": "",
                "longitude": "121.293714",
                "group_b": "",
                "previous_date": "108/07/11",
                "cr_mark": "",
                "previous_year": "2019",
                "visit_time": 0,
                "csbrdy": "80/10/10",
                "cnt": "",
                "event_year": "",
                "fee_time": 0,
                "record_agcsrt": "客戶服務",
                "csidno": "P26810217L",
                "marketing_mark": 0,
                "event_time": ""
            }
        ]        
    },
    header: {
        "message": "查詢成功",
        "userId": "P24162078P",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const getStopEffectAfter = {
    body: {
        "detail": [
            {
                "licon": "C",
                "latitude": "25.088805",
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "csname": "楊○娟",
                "contact_class": "",
                "ann_time": 0,
                "fail_time": 0,
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "group_d": "",
                "undo_marketing": 9,
                "group_a": "",
                "vip": "",
                "customer_view": "",
                "cr_rgb": "",
                "group_c": "",
                "longitude": "121.518453",
                "group_b": "",
                "previous_date": "",
                "cr_mark": "",
                "previous_year": "",
                "visit_time": 0,
                "csbrdy": "53/05/04",
                "cnt": "3",
                "event_year": "",
                "fee_time": 3,
                "record_agcsrt": "",
                "csidno": "Q23018295K",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "licon": "A",
                "latitude": "25.070882",
                "idmark": {},
                "csmtel": "",
                "previous_time": "14:00",
                "csname": "王○玉",
                "contact_class": "",
                "ann_time": 2,
                "fail_time": 0,
                "previous_ser_no": "116620624",
                "event_date": "",
                "event_ser_no": "",
                "group_d": "",
                "undo_marketing": 6,
                "group_a": "",
                "vip": "黃金",
                "customer_view": "受益量多",
                "cr_rgb": "",
                "group_c": "",
                "longitude": "121.476550",
                "group_b": "Y",
                "previous_date": "108/06/19",
                "cr_mark": "",
                "previous_year": "2019",
                "visit_time": 0,
                "csbrdy": "52/04/16",
                "cnt": "",
                "event_year": "",
                "fee_time": 0,
                "record_agcsrt": "客戶服務",
                "csidno": "M26589809O",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "licon": "A",
                "latitude": "0.000000",
                "idmark": {},
                "csmtel": "",
                "previous_time": "16:00",
                "csname": "何○達",
                "contact_class": "",
                "ann_time": 2,
                "fail_time": 0,
                "previous_ser_no": "116706150",
                "event_date": "",
                "event_ser_no": "",
                "group_d": "",
                "undo_marketing": 5,
                "group_a": "",
                "vip": "黃金",
                "customer_view": "",
                "cr_rgb": "",
                "group_c": "",
                "longitude": "0.000000",
                "group_b": "",
                "previous_date": "108/05/28",
                "cr_mark": "",
                "previous_year": "2019",
                "visit_time": 0,
                "csbrdy": "40/09/16",
                "cnt": "",
                "event_year": "",
                "fee_time": 0,
                "record_agcsrt": "客戶服務",
                "csidno": "Y11790715D",
                "marketing_mark": 0,
                "event_time": ""
            }
        ]        
    },
    header: {
        "message": "查詢成功",
        "userId": "P24162078P",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const getRemoteDocumentWarning = {
    body: {
        detail: [
            {
                warranty_no: '1234567890',
                client_symbol: '密戶',
                next_due_day : '108/07/11',
                contract_effectiveness: '終身險滿期',
                payment_pipeline: '人工收費',
                hand_man: '王冠廷',
                insurance_date: "108/09/30",
                csname: "王○芳",
                vip: "",
                visit_time: 0,
            },
        ],
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "A28978309I",
    },
}


// export const  = {
//     body: {
        
//     },
//     header: {
        
//     },
// }
export const getPhysicalMentalDisorder = {
    body: {
        "detail": [
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "source": "",
                "csname": "凌○華",
                "contact_class": "",
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "",
                "sub_cls_nm2": "",
                "undo_marketing": 8,
                "vip": "",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "",
                "sub_cls_nm3": "",
                "previous_year": "",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "42/06/16",
                "sub_cls_nm6": "",
                "cnt": "2",
                "event_year": "",
                "record_agcsrt": "",
                "record_symbol": "",
                "csidno": "D20743301A",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "source": "",
                "csname": "宋○穎",
                "contact_class": "",
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "",
                "sub_cls_nm2": "",
                "undo_marketing": 8,
                "vip": "",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "",
                "sub_cls_nm3": "",
                "previous_year": "",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "55/08/19",
                "sub_cls_nm6": "",
                "cnt": "",
                "event_year": "",
                "record_agcsrt": "",
                "record_symbol": "",
                "csidno": "E10351905C",
                "marketing_mark": 0,
                "event_time": ""
            }
        ]        
    },
    header: {
        "message": "查詢成功",
        "userId": "P24162078P",
        "userDeviceIp": "10.87.23.52",
        "status": "200"        
    },
}

export const getSmallAmountOldAge = {
    body: {
        "detail": [
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "source": "",
                "csname": "凌○華",
                "contact_class": "",
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "",
                "sub_cls_nm2": "",
                "undo_marketing": 8,
                "vip": "",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "",
                "sub_cls_nm3": "",
                "previous_year": "",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "42/06/16",
                "sub_cls_nm6": "",
                "cnt": "3",
                "event_year": "",
                "record_agcsrt": "",
                "record_symbol": "",
                "csidno": "D20743301A",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "",
                "source": "",
                "csname": "宋○穎",
                "contact_class": "",
                "previous_ser_no": "",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "",
                "sub_cls_nm2": "",
                "undo_marketing": 8,
                "vip": "",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "",
                "sub_cls_nm3": "",
                "previous_year": "",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "55/08/19",
                "sub_cls_nm6": "",
                "cnt": "",
                "event_year": "",
                "record_agcsrt": "",
                "record_symbol": "",
                "csidno": "E10351905C",
                "marketing_mark": 0,
                "event_time": ""
            },
            {
                "idmark": {},
                "csmtel": "",
                "previous_time": "08:00",
                "source": "",
                "csname": "呂○金",
                "contact_class": "",
                "previous_ser_no": "97824052",
                "event_date": "",
                "event_ser_no": "",
                "sub_cls_nm1": "人工/自繳",
                "sub_cls_nm2": "滿期金/年金",
                "undo_marketing": 8,
                "vip": "黃金",
                "customer_view": "超值服務",
                "sub_cls_nm7": "",
                "sub_cls_nm8": "",
                "previous_date": "107/08/30",
                "sub_cls_nm3": "保全",
                "previous_year": "2018",
                "sub_cls_nm4": "",
                "sub_cls_nm5": "",
                "csbrdy": "50/02/10",
                "sub_cls_nm6": "",
                "cnt": "",
                "event_year": "",
                "record_agcsrt": "客戶服務",
                "record_symbol": "003",
                "csidno": "P24162078P",
                "marketing_mark": 0,
                "event_time": ""
            }
        ]        
    },
    header: {
        "message": "查詢成功",
        "userId": "P24162078P",
        "userDeviceIp": "10.87.23.52",
        "status": "200"
    },
}

export const getTacount = {
    body: {
        count: "132",
    },
    header: {
        message: "查詢成功",
        status: "200",
        userDeviceIp: "10.87.23.53",
        userId: "C10797445C", 
    },
}

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }

// export const  = {
//     body: {
           
//     },
//     header: {
              
//     },
// }